// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v5.29.3
// source: security.proto

/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { Security as Security1 } from "./candle-data-depot-common";
import { Exchange, exchangeFromJSON, exchangeToJSON, Expiry } from "./common";

export const protobufPackage = "com.tick2trade.api.security";

export enum Segment {
  SEGMENT_UNKNOWN = 0,
  CM = 1,
  FO = 2,
  CD = 3,
  COM = 4,
  CURRENCY = 5,
  UNRECOGNIZED = -1,
}

export function segmentFromJSON(object: any): Segment {
  switch (object) {
    case 0:
    case "SEGMENT_UNKNOWN":
      return Segment.SEGMENT_UNKNOWN;
    case 1:
    case "CM":
      return Segment.CM;
    case 2:
    case "FO":
      return Segment.FO;
    case 3:
    case "CD":
      return Segment.CD;
    case 4:
    case "COM":
      return Segment.COM;
    case 5:
    case "CURRENCY":
      return Segment.CURRENCY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Segment.UNRECOGNIZED;
  }
}

export function segmentToJSON(object: Segment): string {
  switch (object) {
    case Segment.SEGMENT_UNKNOWN:
      return "SEGMENT_UNKNOWN";
    case Segment.CM:
      return "CM";
    case Segment.FO:
      return "FO";
    case Segment.CD:
      return "CD";
    case Segment.COM:
      return "COM";
    case Segment.CURRENCY:
      return "CURRENCY";
    case Segment.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum Instrument {
  INSTRUMENT_UNKNOWN = 0,
  OPTSTK = 1,
  FUTSTK = 2,
  OPTIDX = 3,
  FUTIDX = 4,
  FUTIVX = 5,
  EQUITY = 6,
  INX = 7,
  CUR = 8,
  UNDCUR = 9,
  UNDIRC = 10,
  UNDIRD = 11,
  UNDIRT = 12,
  IDX = 13,
  FUTCUR = 14,
  FUTIRC = 15,
  OPTIRC = 16,
  OPTCUR = 17,
  FUTIRT = 18,
  ETF = 19,
  REIT = 20,
  INVIT = 21,
  MF_CLOSED = 22,
  AIF = 23,
  SGB = 24,
  GOVT_SECURITY = 25,
  SDL = 26,
  TBILL = 27,
  CORP_BOND = 28,
  PREFSHARES = 29,
  WARRANT = 30,
  PARTLY_PAID = 31,
  UNRECOGNIZED = -1,
}

export function instrumentFromJSON(object: any): Instrument {
  switch (object) {
    case 0:
    case "INSTRUMENT_UNKNOWN":
      return Instrument.INSTRUMENT_UNKNOWN;
    case 1:
    case "OPTSTK":
      return Instrument.OPTSTK;
    case 2:
    case "FUTSTK":
      return Instrument.FUTSTK;
    case 3:
    case "OPTIDX":
      return Instrument.OPTIDX;
    case 4:
    case "FUTIDX":
      return Instrument.FUTIDX;
    case 5:
    case "FUTIVX":
      return Instrument.FUTIVX;
    case 6:
    case "EQUITY":
      return Instrument.EQUITY;
    case 7:
    case "INX":
      return Instrument.INX;
    case 8:
    case "CUR":
      return Instrument.CUR;
    case 9:
    case "UNDCUR":
      return Instrument.UNDCUR;
    case 10:
    case "UNDIRC":
      return Instrument.UNDIRC;
    case 11:
    case "UNDIRD":
      return Instrument.UNDIRD;
    case 12:
    case "UNDIRT":
      return Instrument.UNDIRT;
    case 13:
    case "IDX":
      return Instrument.IDX;
    case 14:
    case "FUTCUR":
      return Instrument.FUTCUR;
    case 15:
    case "FUTIRC":
      return Instrument.FUTIRC;
    case 16:
    case "OPTIRC":
      return Instrument.OPTIRC;
    case 17:
    case "OPTCUR":
      return Instrument.OPTCUR;
    case 18:
    case "FUTIRT":
      return Instrument.FUTIRT;
    case 19:
    case "ETF":
      return Instrument.ETF;
    case 20:
    case "REIT":
      return Instrument.REIT;
    case 21:
    case "INVIT":
      return Instrument.INVIT;
    case 22:
    case "MF_CLOSED":
      return Instrument.MF_CLOSED;
    case 23:
    case "AIF":
      return Instrument.AIF;
    case 24:
    case "SGB":
      return Instrument.SGB;
    case 25:
    case "GOVT_SECURITY":
      return Instrument.GOVT_SECURITY;
    case 26:
    case "SDL":
      return Instrument.SDL;
    case 27:
    case "TBILL":
      return Instrument.TBILL;
    case 28:
    case "CORP_BOND":
      return Instrument.CORP_BOND;
    case 29:
    case "PREFSHARES":
      return Instrument.PREFSHARES;
    case 30:
    case "WARRANT":
      return Instrument.WARRANT;
    case 31:
    case "PARTLY_PAID":
      return Instrument.PARTLY_PAID;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Instrument.UNRECOGNIZED;
  }
}

export function instrumentToJSON(object: Instrument): string {
  switch (object) {
    case Instrument.INSTRUMENT_UNKNOWN:
      return "INSTRUMENT_UNKNOWN";
    case Instrument.OPTSTK:
      return "OPTSTK";
    case Instrument.FUTSTK:
      return "FUTSTK";
    case Instrument.OPTIDX:
      return "OPTIDX";
    case Instrument.FUTIDX:
      return "FUTIDX";
    case Instrument.FUTIVX:
      return "FUTIVX";
    case Instrument.EQUITY:
      return "EQUITY";
    case Instrument.INX:
      return "INX";
    case Instrument.CUR:
      return "CUR";
    case Instrument.UNDCUR:
      return "UNDCUR";
    case Instrument.UNDIRC:
      return "UNDIRC";
    case Instrument.UNDIRD:
      return "UNDIRD";
    case Instrument.UNDIRT:
      return "UNDIRT";
    case Instrument.IDX:
      return "IDX";
    case Instrument.FUTCUR:
      return "FUTCUR";
    case Instrument.FUTIRC:
      return "FUTIRC";
    case Instrument.OPTIRC:
      return "OPTIRC";
    case Instrument.OPTCUR:
      return "OPTCUR";
    case Instrument.FUTIRT:
      return "FUTIRT";
    case Instrument.ETF:
      return "ETF";
    case Instrument.REIT:
      return "REIT";
    case Instrument.INVIT:
      return "INVIT";
    case Instrument.MF_CLOSED:
      return "MF_CLOSED";
    case Instrument.AIF:
      return "AIF";
    case Instrument.SGB:
      return "SGB";
    case Instrument.GOVT_SECURITY:
      return "GOVT_SECURITY";
    case Instrument.SDL:
      return "SDL";
    case Instrument.TBILL:
      return "TBILL";
    case Instrument.CORP_BOND:
      return "CORP_BOND";
    case Instrument.PREFSHARES:
      return "PREFSHARES";
    case Instrument.WARRANT:
      return "WARRANT";
    case Instrument.PARTLY_PAID:
      return "PARTLY_PAID";
    case Instrument.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum OptionType {
  OPTION_TYPE_UNKNOWN = 0,
  CE = 1,
  PE = 2,
  XX = 3,
  UNRECOGNIZED = -1,
}

export function optionTypeFromJSON(object: any): OptionType {
  switch (object) {
    case 0:
    case "OPTION_TYPE_UNKNOWN":
      return OptionType.OPTION_TYPE_UNKNOWN;
    case 1:
    case "CE":
      return OptionType.CE;
    case 2:
    case "PE":
      return OptionType.PE;
    case 3:
    case "XX":
      return OptionType.XX;
    case -1:
    case "UNRECOGNIZED":
    default:
      return OptionType.UNRECOGNIZED;
  }
}

export function optionTypeToJSON(object: OptionType): string {
  switch (object) {
    case OptionType.OPTION_TYPE_UNKNOWN:
      return "OPTION_TYPE_UNKNOWN";
    case OptionType.CE:
      return "CE";
    case OptionType.PE:
      return "PE";
    case OptionType.XX:
      return "XX";
    case OptionType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum SecurityStatus {
  SECURITY_STATUS_UNKNOWN = 0,
  PRE_OPEN = 1,
  OPEN = 2,
  SUSPENDED = 3,
  PRE_OPEN_EXTENDED = 4,
  STOCK_OPEN_WITH_MARKET = 5,
  PRICE_DISCOVERY = 6,
  UNRECOGNIZED = -1,
}

export function securityStatusFromJSON(object: any): SecurityStatus {
  switch (object) {
    case 0:
    case "SECURITY_STATUS_UNKNOWN":
      return SecurityStatus.SECURITY_STATUS_UNKNOWN;
    case 1:
    case "PRE_OPEN":
      return SecurityStatus.PRE_OPEN;
    case 2:
    case "OPEN":
      return SecurityStatus.OPEN;
    case 3:
    case "SUSPENDED":
      return SecurityStatus.SUSPENDED;
    case 4:
    case "PRE_OPEN_EXTENDED":
      return SecurityStatus.PRE_OPEN_EXTENDED;
    case 5:
    case "STOCK_OPEN_WITH_MARKET":
      return SecurityStatus.STOCK_OPEN_WITH_MARKET;
    case 6:
    case "PRICE_DISCOVERY":
      return SecurityStatus.PRICE_DISCOVERY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SecurityStatus.UNRECOGNIZED;
  }
}

export function securityStatusToJSON(object: SecurityStatus): string {
  switch (object) {
    case SecurityStatus.SECURITY_STATUS_UNKNOWN:
      return "SECURITY_STATUS_UNKNOWN";
    case SecurityStatus.PRE_OPEN:
      return "PRE_OPEN";
    case SecurityStatus.OPEN:
      return "OPEN";
    case SecurityStatus.SUSPENDED:
      return "SUSPENDED";
    case SecurityStatus.PRE_OPEN_EXTENDED:
      return "PRE_OPEN_EXTENDED";
    case SecurityStatus.STOCK_OPEN_WITH_MARKET:
      return "STOCK_OPEN_WITH_MARKET";
    case SecurityStatus.PRICE_DISCOVERY:
      return "PRICE_DISCOVERY";
    case SecurityStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum SettlementIndicator {
  SETTLEMENT_INDICATOR_UNKNOWN = 0,
  CASH = 1,
  PHYSICAL = 2,
  UNRECOGNIZED = -1,
}

export function settlementIndicatorFromJSON(object: any): SettlementIndicator {
  switch (object) {
    case 0:
    case "SETTLEMENT_INDICATOR_UNKNOWN":
      return SettlementIndicator.SETTLEMENT_INDICATOR_UNKNOWN;
    case 1:
    case "CASH":
      return SettlementIndicator.CASH;
    case 2:
    case "PHYSICAL":
      return SettlementIndicator.PHYSICAL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SettlementIndicator.UNRECOGNIZED;
  }
}

export function settlementIndicatorToJSON(object: SettlementIndicator): string {
  switch (object) {
    case SettlementIndicator.SETTLEMENT_INDICATOR_UNKNOWN:
      return "SETTLEMENT_INDICATOR_UNKNOWN";
    case SettlementIndicator.CASH:
      return "CASH";
    case SettlementIndicator.PHYSICAL:
      return "PHYSICAL";
    case SettlementIndicator.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum CallAuctionType {
  NOT_PART_OF_PRE_OPEN = 0,
  /** SPOS_IPO - Special Pre open session – IPO scrip */
  SPOS_IPO = 1,
  /** SPOS_RELIST - Special Pre open session – Relist scrip */
  SPOS_RELIST = 2,
  /** PCAS - Periodic call auction session */
  PCAS = 3,
  /** SPECIAL_CALL_AUCTION_IC_IHC - Special Call Auction session – ICs/IHCs */
  SPECIAL_CALL_AUCTION_IC_IHC = 4,
  /** PRE_OPEN_CALL_AUCTION - Normal Securities like HDFC, Reliance */
  PRE_OPEN_CALL_AUCTION = 5,
  UNRECOGNIZED = -1,
}

export function callAuctionTypeFromJSON(object: any): CallAuctionType {
  switch (object) {
    case 0:
    case "NOT_PART_OF_PRE_OPEN":
      return CallAuctionType.NOT_PART_OF_PRE_OPEN;
    case 1:
    case "SPOS_IPO":
      return CallAuctionType.SPOS_IPO;
    case 2:
    case "SPOS_RELIST":
      return CallAuctionType.SPOS_RELIST;
    case 3:
    case "PCAS":
      return CallAuctionType.PCAS;
    case 4:
    case "SPECIAL_CALL_AUCTION_IC_IHC":
      return CallAuctionType.SPECIAL_CALL_AUCTION_IC_IHC;
    case 5:
    case "PRE_OPEN_CALL_AUCTION":
      return CallAuctionType.PRE_OPEN_CALL_AUCTION;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CallAuctionType.UNRECOGNIZED;
  }
}

export function callAuctionTypeToJSON(object: CallAuctionType): string {
  switch (object) {
    case CallAuctionType.NOT_PART_OF_PRE_OPEN:
      return "NOT_PART_OF_PRE_OPEN";
    case CallAuctionType.SPOS_IPO:
      return "SPOS_IPO";
    case CallAuctionType.SPOS_RELIST:
      return "SPOS_RELIST";
    case CallAuctionType.PCAS:
      return "PCAS";
    case CallAuctionType.SPECIAL_CALL_AUCTION_IC_IHC:
      return "SPECIAL_CALL_AUCTION_IC_IHC";
    case CallAuctionType.PRE_OPEN_CALL_AUCTION:
      return "PRE_OPEN_CALL_AUCTION";
    case CallAuctionType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface SecurityCategory {
  code: SecurityCategory_CategoryCode;
  displayName: string;
  /** TradingView-style subtypes under this category (e.g. Funds → ETF, REIT). Empty for Options. */
  subtypes: SecurityCategory_InstrumentSubtype[];
}

export enum SecurityCategory_CategoryCode {
  CATEGORY_CODE_UNKNOWN = 0,
  ALL = 1,
  STOCKS = 2,
  FUTURES = 3,
  OPTIONS = 4,
  INDEX = 5,
  CURRENCY = 6,
  SPREADS = 7,
  FUNDS = 8,
  BONDS = 9,
  UNRECOGNIZED = -1,
}

export function securityCategory_CategoryCodeFromJSON(object: any): SecurityCategory_CategoryCode {
  switch (object) {
    case 0:
    case "CATEGORY_CODE_UNKNOWN":
      return SecurityCategory_CategoryCode.CATEGORY_CODE_UNKNOWN;
    case 1:
    case "ALL":
      return SecurityCategory_CategoryCode.ALL;
    case 2:
    case "STOCKS":
      return SecurityCategory_CategoryCode.STOCKS;
    case 3:
    case "FUTURES":
      return SecurityCategory_CategoryCode.FUTURES;
    case 4:
    case "OPTIONS":
      return SecurityCategory_CategoryCode.OPTIONS;
    case 5:
    case "INDEX":
      return SecurityCategory_CategoryCode.INDEX;
    case 6:
    case "CURRENCY":
      return SecurityCategory_CategoryCode.CURRENCY;
    case 7:
    case "SPREADS":
      return SecurityCategory_CategoryCode.SPREADS;
    case 8:
    case "FUNDS":
      return SecurityCategory_CategoryCode.FUNDS;
    case 9:
    case "BONDS":
      return SecurityCategory_CategoryCode.BONDS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SecurityCategory_CategoryCode.UNRECOGNIZED;
  }
}

export function securityCategory_CategoryCodeToJSON(object: SecurityCategory_CategoryCode): string {
  switch (object) {
    case SecurityCategory_CategoryCode.CATEGORY_CODE_UNKNOWN:
      return "CATEGORY_CODE_UNKNOWN";
    case SecurityCategory_CategoryCode.ALL:
      return "ALL";
    case SecurityCategory_CategoryCode.STOCKS:
      return "STOCKS";
    case SecurityCategory_CategoryCode.FUTURES:
      return "FUTURES";
    case SecurityCategory_CategoryCode.OPTIONS:
      return "OPTIONS";
    case SecurityCategory_CategoryCode.INDEX:
      return "INDEX";
    case SecurityCategory_CategoryCode.CURRENCY:
      return "CURRENCY";
    case SecurityCategory_CategoryCode.SPREADS:
      return "SPREADS";
    case SecurityCategory_CategoryCode.FUNDS:
      return "FUNDS";
    case SecurityCategory_CategoryCode.BONDS:
      return "BONDS";
    case SecurityCategory_CategoryCode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface SecurityCategory_InstrumentSubtype {
  /** proto Instrument name, e.g. ETF */
  instrument: string;
  /** UI label, e.g. ETF */
  displayName: string;
}

export interface Securities {
  securities: Security[];
}

export interface Security {
  exchange: Exchange;
  code: string;
  segment?: Segment | undefined;
  symbol?: string | undefined;
  exchangeSymbol?: string | undefined;
  displayName?: string | undefined;
  series?: string | undefined;
  priceMultiplier?: number | undefined;
  name?: string | undefined;
  logoUrl?: string | undefined;
  underlyingSecurityCode?: string | undefined;
  categoryCode?: SecurityCategory_CategoryCode | undefined;
  hasFo?: boolean | undefined;
  lotSize?: number | undefined;
  volumeFreezeQuantity?: number | undefined;
  tickSize?: number | undefined;
  instrument?: string | undefined;
  strikePrice?: number | undefined;
  optionType?: OptionType | undefined;
  expiry?: Expiry | undefined;
  derived?: boolean | undefined;
  urlIdentifier?: string | undefined;
  companyCode?: string | undefined;
  surveillanceIndicator?: number | undefined;
  surveillanceIndicatorText?: string | undefined;
  partOfCAS?: boolean | undefined;
  tradeable?: boolean | undefined;
}

export interface DerivedSecurity {
  security: Security | undefined;
  referencedSecurity: Security | undefined;
}

export interface SecurityExpression {
  id: string;
  expression: string;
  name: string;
  securities: Security[];
  expired: boolean;
}

export interface SecurityCategories {
  categories: SecurityCategory[];
}

export interface LookupSecuritiesBySymbolRequest {
  securities: LookupSecuritiesBySymbolRequest_Security[];
}

export interface LookupSecuritiesBySymbolRequest_Security {
  exchange: Exchange;
  symbol: string;
}

export interface LookupSecuritiesBySymbolResponse {
  securities: Security[];
}

export interface SearchSecurityRequest {
  searchText: string;
  exchange: Exchange;
  categoryCode: SecurityCategory_CategoryCode;
  pageNumber: number;
  pageSize: number;
  hasFo?:
    | boolean
    | undefined;
  /** Optional instrument subtype filter within category_code (e.g. ETF under FUNDS). */
  instrument?: string | undefined;
}

export interface SearchSecurityResponse {
  searchText: string;
  securitySearchItems: SearchSecurityResponse_SecuritySearchItem[];
  totalCount: number;
}

export interface SearchSecurityResponse_Security {
  exchange: Exchange;
  code: string;
  symbol?: string | undefined;
  displayName?: string | undefined;
  series?: string | undefined;
  priceMultiplier?: number | undefined;
  categoryCode?: SecurityCategory_CategoryCode | undefined;
  logoUrl?:
    | string
    | undefined;
  /** Instrument name for subtype labels in search (e.g. ETF under FUNDS). */
  instrument?: string | undefined;
}

export interface SearchSecurityResponse_SecuritySearchItem {
  isExpression: boolean;
  expression?: SecurityExpression | undefined;
  securities: SearchSecurityResponse_Security[];
}

export interface SecuritySnapshots {
  securitySnapshots: SecuritySnapshot[];
}

export interface SecuritySnapshot {
  security: Security1 | undefined;
  lastTradedPrice: number;
  volume: number;
  previousClose: number;
  lastTradedTime: number;
  referencedSecurity?: Security1 | undefined;
}

export interface OrderBooks {
  orderBooks: OrderBook[];
}

export interface OrderBook {
  security: Security1 | undefined;
  lastTradedTime: number;
  lastTradedPrice: number;
  volumeTradedToday: number;
  totalBuyQuantity: number;
  totalSellQuantity: number;
  open: number;
  high: number;
  low: number;
  close: number;
  timestamp: number;
  lowerCircuit: number;
  upperCircuit: number;
  bids: OrderBook_OrderBookQuote[];
  asks: OrderBook_OrderBookQuote[];
  referencedSecurity: Security1 | undefined;
  lastTradedQuantity: number;
  averageTradedPrice: number;
  session: OrderBook_Session;
  auction?: OrderBook_AuctionState | undefined;
  openInterest?: number | undefined;
  inav?: number | undefined;
}

export enum OrderBook_Session {
  SESSION_UNKNOWN = 0,
  CONTINUOUS = 1,
  PRE_OPEN = 2,
  CALL_AUCTION = 3,
  CLOSING_AUCTION = 4,
  UNRECOGNIZED = -1,
}

export function orderBook_SessionFromJSON(object: any): OrderBook_Session {
  switch (object) {
    case 0:
    case "SESSION_UNKNOWN":
      return OrderBook_Session.SESSION_UNKNOWN;
    case 1:
    case "CONTINUOUS":
      return OrderBook_Session.CONTINUOUS;
    case 2:
    case "PRE_OPEN":
      return OrderBook_Session.PRE_OPEN;
    case 3:
    case "CALL_AUCTION":
      return OrderBook_Session.CALL_AUCTION;
    case 4:
    case "CLOSING_AUCTION":
      return OrderBook_Session.CLOSING_AUCTION;
    case -1:
    case "UNRECOGNIZED":
    default:
      return OrderBook_Session.UNRECOGNIZED;
  }
}

export function orderBook_SessionToJSON(object: OrderBook_Session): string {
  switch (object) {
    case OrderBook_Session.SESSION_UNKNOWN:
      return "SESSION_UNKNOWN";
    case OrderBook_Session.CONTINUOUS:
      return "CONTINUOUS";
    case OrderBook_Session.PRE_OPEN:
      return "PRE_OPEN";
    case OrderBook_Session.CALL_AUCTION:
      return "CALL_AUCTION";
    case OrderBook_Session.CLOSING_AUCTION:
      return "CLOSING_AUCTION";
    case OrderBook_Session.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface OrderBook_OrderBookQuote {
  price: number;
  quantity: number;
  numberOfOrders: number;
}

export interface OrderBook_AuctionState {
  indicativePrice?: number | undefined;
  indicativeQuantity?: number | undefined;
  totalImbalanceQuantity?: number | undefined;
  marketImbalanceQuantity?: number | undefined;
  referencePrice?: number | undefined;
}

export interface DataUpdateMessage {
  type: DataUpdateMessage_Type;
  parameters: DataUpdateMessage_Parameter[];
}

export enum DataUpdateMessage_Type {
  DATA_UPDATE_MESSAGE_UNKNOWN = 0,
  PERIODIC_SCREENER_REFRESH = 1,
  FULL_SCREENER_REFRESH = 2,
  CACHE_RELOAD = 3,
  SECURITY_INFO_UPDATE = 4,
  UNRECOGNIZED = -1,
}

export function dataUpdateMessage_TypeFromJSON(object: any): DataUpdateMessage_Type {
  switch (object) {
    case 0:
    case "DATA_UPDATE_MESSAGE_UNKNOWN":
      return DataUpdateMessage_Type.DATA_UPDATE_MESSAGE_UNKNOWN;
    case 1:
    case "PERIODIC_SCREENER_REFRESH":
      return DataUpdateMessage_Type.PERIODIC_SCREENER_REFRESH;
    case 2:
    case "FULL_SCREENER_REFRESH":
      return DataUpdateMessage_Type.FULL_SCREENER_REFRESH;
    case 3:
    case "CACHE_RELOAD":
      return DataUpdateMessage_Type.CACHE_RELOAD;
    case 4:
    case "SECURITY_INFO_UPDATE":
      return DataUpdateMessage_Type.SECURITY_INFO_UPDATE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DataUpdateMessage_Type.UNRECOGNIZED;
  }
}

export function dataUpdateMessage_TypeToJSON(object: DataUpdateMessage_Type): string {
  switch (object) {
    case DataUpdateMessage_Type.DATA_UPDATE_MESSAGE_UNKNOWN:
      return "DATA_UPDATE_MESSAGE_UNKNOWN";
    case DataUpdateMessage_Type.PERIODIC_SCREENER_REFRESH:
      return "PERIODIC_SCREENER_REFRESH";
    case DataUpdateMessage_Type.FULL_SCREENER_REFRESH:
      return "FULL_SCREENER_REFRESH";
    case DataUpdateMessage_Type.CACHE_RELOAD:
      return "CACHE_RELOAD";
    case DataUpdateMessage_Type.SECURITY_INFO_UPDATE:
      return "SECURITY_INFO_UPDATE";
    case DataUpdateMessage_Type.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface DataUpdateMessage_Parameter {
  name: string;
  value: string;
}

export interface FoProto {
  optionsSecurities: FoProto_OptionSecurityProto[];
  futuresSecurities: FoProto_FutureSecurityProto[];
  derivedSecurities: FoProto_DerivedSecurityProto[];
}

export interface FoProto_OptionSecurityProto {
  /** NIFTY_50_14_NOV_ */
  securityCodePrefix: string;
  symbolPrefix?: string | undefined;
  displayNamePrefix?: string | undefined;
  priceMultiplier?: number | undefined;
  lotSize?: number | undefined;
  volumeFreezeQuantity?: number | undefined;
  tickSize?: number | undefined;
  expiry: Expiry | undefined;
  strikes: number[];
  name?: string | undefined;
}

export interface FoProto_FutureSecurityProto {
  code: string;
  symbol?: string | undefined;
  displayName?: string | undefined;
  priceMultiplier?: number | undefined;
  lotSize?: number | undefined;
  volumeFreezeQuantity?: number | undefined;
  tickSize?: number | undefined;
  expiry?: Expiry | undefined;
  name?: string | undefined;
}

export interface FoProto_DerivedSecurityProto {
  code: string;
  symbol?: string | undefined;
  displayName?: string | undefined;
  expiry?: Expiry | undefined;
  categoryCode?: SecurityCategory_CategoryCode | undefined;
  optionType?: OptionType | undefined;
}

export interface CashSecurityProto {
  code: string;
  symbol?: string | undefined;
  displayName?: string | undefined;
  series?: string | undefined;
  priceMultiplier?: number | undefined;
  logoUrl?: string | undefined;
  categoryCode?: SecurityCategory_CategoryCode | undefined;
  hasFo?: boolean | undefined;
  lotSize?: number | undefined;
  volumeFreezeQuantity?: number | undefined;
  tickSize?: number | undefined;
  instrument?: string | undefined;
  urlIdentifier?: string | undefined;
  foData?: FoProto | undefined;
  companyCode?: string | undefined;
  surveillanceIndicator?: number | undefined;
  hasComponents?: boolean | undefined;
  surveillanceIndicatorText?: string | undefined;
  exchangeSymbol?: string | undefined;
  partOfCAS?: boolean | undefined;
  tradeable?: boolean | undefined;
}

export interface ExchangeSecurityProto {
  exchange: Exchange;
  cashSecurities: CashSecurityProto[];
}

export interface AllSecuritiesResponseProto {
  exchangeSecurities: ExchangeSecurityProto[];
}

export interface PrimaryCompanyIdentifier {
  primaryCode: string;
  primaryExchange: string;
}

function createBaseSecurityCategory(): SecurityCategory {
  return { code: 0, displayName: "", subtypes: [] };
}

export const SecurityCategory = {
  encode(message: SecurityCategory, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.code !== 0) {
      writer.uint32(8).int32(message.code);
    }
    if (message.displayName !== "") {
      writer.uint32(18).string(message.displayName);
    }
    for (const v of message.subtypes) {
      SecurityCategory_InstrumentSubtype.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SecurityCategory {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSecurityCategory();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.code = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.displayName = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.subtypes.push(SecurityCategory_InstrumentSubtype.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SecurityCategory {
    return {
      code: isSet(object.code) ? securityCategory_CategoryCodeFromJSON(object.code) : 0,
      displayName: isSet(object.displayName) ? globalThis.String(object.displayName) : "",
      subtypes: globalThis.Array.isArray(object?.subtypes)
        ? object.subtypes.map((e: any) => SecurityCategory_InstrumentSubtype.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SecurityCategory): unknown {
    const obj: any = {};
    if (message.code !== 0) {
      obj.code = securityCategory_CategoryCodeToJSON(message.code);
    }
    if (message.displayName !== "") {
      obj.displayName = message.displayName;
    }
    if (message.subtypes?.length) {
      obj.subtypes = message.subtypes.map((e) => SecurityCategory_InstrumentSubtype.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SecurityCategory>, I>>(base?: I): SecurityCategory {
    return SecurityCategory.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SecurityCategory>, I>>(object: I): SecurityCategory {
    const message = createBaseSecurityCategory();
    message.code = object.code ?? 0;
    message.displayName = object.displayName ?? "";
    message.subtypes = object.subtypes?.map((e) => SecurityCategory_InstrumentSubtype.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSecurityCategory_InstrumentSubtype(): SecurityCategory_InstrumentSubtype {
  return { instrument: "", displayName: "" };
}

export const SecurityCategory_InstrumentSubtype = {
  encode(message: SecurityCategory_InstrumentSubtype, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.instrument !== "") {
      writer.uint32(10).string(message.instrument);
    }
    if (message.displayName !== "") {
      writer.uint32(18).string(message.displayName);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SecurityCategory_InstrumentSubtype {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSecurityCategory_InstrumentSubtype();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.instrument = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.displayName = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SecurityCategory_InstrumentSubtype {
    return {
      instrument: isSet(object.instrument) ? globalThis.String(object.instrument) : "",
      displayName: isSet(object.displayName) ? globalThis.String(object.displayName) : "",
    };
  },

  toJSON(message: SecurityCategory_InstrumentSubtype): unknown {
    const obj: any = {};
    if (message.instrument !== "") {
      obj.instrument = message.instrument;
    }
    if (message.displayName !== "") {
      obj.displayName = message.displayName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SecurityCategory_InstrumentSubtype>, I>>(
    base?: I,
  ): SecurityCategory_InstrumentSubtype {
    return SecurityCategory_InstrumentSubtype.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SecurityCategory_InstrumentSubtype>, I>>(
    object: I,
  ): SecurityCategory_InstrumentSubtype {
    const message = createBaseSecurityCategory_InstrumentSubtype();
    message.instrument = object.instrument ?? "";
    message.displayName = object.displayName ?? "";
    return message;
  },
};

function createBaseSecurities(): Securities {
  return { securities: [] };
}

export const Securities = {
  encode(message: Securities, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.securities) {
      Security.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Securities {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSecurities();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.securities.push(Security.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Securities {
    return {
      securities: globalThis.Array.isArray(object?.securities)
        ? object.securities.map((e: any) => Security.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Securities): unknown {
    const obj: any = {};
    if (message.securities?.length) {
      obj.securities = message.securities.map((e) => Security.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Securities>, I>>(base?: I): Securities {
    return Securities.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Securities>, I>>(object: I): Securities {
    const message = createBaseSecurities();
    message.securities = object.securities?.map((e) => Security.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSecurity(): Security {
  return {
    exchange: 0,
    code: "",
    segment: undefined,
    symbol: undefined,
    exchangeSymbol: undefined,
    displayName: undefined,
    series: undefined,
    priceMultiplier: undefined,
    name: undefined,
    logoUrl: undefined,
    underlyingSecurityCode: undefined,
    categoryCode: undefined,
    hasFo: undefined,
    lotSize: undefined,
    volumeFreezeQuantity: undefined,
    tickSize: undefined,
    instrument: undefined,
    strikePrice: undefined,
    optionType: undefined,
    expiry: undefined,
    derived: undefined,
    urlIdentifier: undefined,
    companyCode: undefined,
    surveillanceIndicator: undefined,
    surveillanceIndicatorText: undefined,
    partOfCAS: undefined,
    tradeable: undefined,
  };
}

export const Security = {
  encode(message: Security, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange);
    }
    if (message.code !== "") {
      writer.uint32(18).string(message.code);
    }
    if (message.segment !== undefined) {
      writer.uint32(24).int32(message.segment);
    }
    if (message.symbol !== undefined) {
      writer.uint32(34).string(message.symbol);
    }
    if (message.exchangeSymbol !== undefined) {
      writer.uint32(42).string(message.exchangeSymbol);
    }
    if (message.displayName !== undefined) {
      writer.uint32(50).string(message.displayName);
    }
    if (message.series !== undefined) {
      writer.uint32(58).string(message.series);
    }
    if (message.priceMultiplier !== undefined) {
      writer.uint32(64).int32(message.priceMultiplier);
    }
    if (message.name !== undefined) {
      writer.uint32(74).string(message.name);
    }
    if (message.logoUrl !== undefined) {
      writer.uint32(82).string(message.logoUrl);
    }
    if (message.underlyingSecurityCode !== undefined) {
      writer.uint32(98).string(message.underlyingSecurityCode);
    }
    if (message.categoryCode !== undefined) {
      writer.uint32(112).int32(message.categoryCode);
    }
    if (message.hasFo !== undefined) {
      writer.uint32(128).bool(message.hasFo);
    }
    if (message.lotSize !== undefined) {
      writer.uint32(144).int32(message.lotSize);
    }
    if (message.volumeFreezeQuantity !== undefined) {
      writer.uint32(160).int32(message.volumeFreezeQuantity);
    }
    if (message.tickSize !== undefined) {
      writer.uint32(176).int32(message.tickSize);
    }
    if (message.instrument !== undefined) {
      writer.uint32(186).string(message.instrument);
    }
    if (message.strikePrice !== undefined) {
      writer.uint32(192).int32(message.strikePrice);
    }
    if (message.optionType !== undefined) {
      writer.uint32(200).int32(message.optionType);
    }
    if (message.expiry !== undefined) {
      Expiry.encode(message.expiry, writer.uint32(210).fork()).ldelim();
    }
    if (message.derived !== undefined) {
      writer.uint32(224).bool(message.derived);
    }
    if (message.urlIdentifier !== undefined) {
      writer.uint32(242).string(message.urlIdentifier);
    }
    if (message.companyCode !== undefined) {
      writer.uint32(250).string(message.companyCode);
    }
    if (message.surveillanceIndicator !== undefined) {
      writer.uint32(256).int32(message.surveillanceIndicator);
    }
    if (message.surveillanceIndicatorText !== undefined) {
      writer.uint32(266).string(message.surveillanceIndicatorText);
    }
    if (message.partOfCAS !== undefined) {
      writer.uint32(272).bool(message.partOfCAS);
    }
    if (message.tradeable !== undefined) {
      writer.uint32(280).bool(message.tradeable);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Security {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSecurity();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.exchange = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.code = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.segment = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.symbol = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.exchangeSymbol = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.displayName = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.series = reader.string();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.priceMultiplier = reader.int32();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.name = reader.string();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.logoUrl = reader.string();
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.underlyingSecurityCode = reader.string();
          continue;
        case 14:
          if (tag !== 112) {
            break;
          }

          message.categoryCode = reader.int32() as any;
          continue;
        case 16:
          if (tag !== 128) {
            break;
          }

          message.hasFo = reader.bool();
          continue;
        case 18:
          if (tag !== 144) {
            break;
          }

          message.lotSize = reader.int32();
          continue;
        case 20:
          if (tag !== 160) {
            break;
          }

          message.volumeFreezeQuantity = reader.int32();
          continue;
        case 22:
          if (tag !== 176) {
            break;
          }

          message.tickSize = reader.int32();
          continue;
        case 23:
          if (tag !== 186) {
            break;
          }

          message.instrument = reader.string();
          continue;
        case 24:
          if (tag !== 192) {
            break;
          }

          message.strikePrice = reader.int32();
          continue;
        case 25:
          if (tag !== 200) {
            break;
          }

          message.optionType = reader.int32() as any;
          continue;
        case 26:
          if (tag !== 210) {
            break;
          }

          message.expiry = Expiry.decode(reader, reader.uint32());
          continue;
        case 28:
          if (tag !== 224) {
            break;
          }

          message.derived = reader.bool();
          continue;
        case 30:
          if (tag !== 242) {
            break;
          }

          message.urlIdentifier = reader.string();
          continue;
        case 31:
          if (tag !== 250) {
            break;
          }

          message.companyCode = reader.string();
          continue;
        case 32:
          if (tag !== 256) {
            break;
          }

          message.surveillanceIndicator = reader.int32();
          continue;
        case 33:
          if (tag !== 266) {
            break;
          }

          message.surveillanceIndicatorText = reader.string();
          continue;
        case 34:
          if (tag !== 272) {
            break;
          }

          message.partOfCAS = reader.bool();
          continue;
        case 35:
          if (tag !== 280) {
            break;
          }

          message.tradeable = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Security {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      segment: isSet(object.segment) ? segmentFromJSON(object.segment) : undefined,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : undefined,
      exchangeSymbol: isSet(object.exchangeSymbol) ? globalThis.String(object.exchangeSymbol) : undefined,
      displayName: isSet(object.displayName) ? globalThis.String(object.displayName) : undefined,
      series: isSet(object.series) ? globalThis.String(object.series) : undefined,
      priceMultiplier: isSet(object.priceMultiplier) ? globalThis.Number(object.priceMultiplier) : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      logoUrl: isSet(object.logoUrl) ? globalThis.String(object.logoUrl) : undefined,
      underlyingSecurityCode: isSet(object.underlyingSecurityCode)
        ? globalThis.String(object.underlyingSecurityCode)
        : undefined,
      categoryCode: isSet(object.categoryCode) ? securityCategory_CategoryCodeFromJSON(object.categoryCode) : undefined,
      hasFo: isSet(object.hasFo) ? globalThis.Boolean(object.hasFo) : undefined,
      lotSize: isSet(object.lotSize) ? globalThis.Number(object.lotSize) : undefined,
      volumeFreezeQuantity: isSet(object.volumeFreezeQuantity)
        ? globalThis.Number(object.volumeFreezeQuantity)
        : undefined,
      tickSize: isSet(object.tickSize) ? globalThis.Number(object.tickSize) : undefined,
      instrument: isSet(object.instrument) ? globalThis.String(object.instrument) : undefined,
      strikePrice: isSet(object.strikePrice) ? globalThis.Number(object.strikePrice) : undefined,
      optionType: isSet(object.optionType) ? optionTypeFromJSON(object.optionType) : undefined,
      expiry: isSet(object.expiry) ? Expiry.fromJSON(object.expiry) : undefined,
      derived: isSet(object.derived) ? globalThis.Boolean(object.derived) : undefined,
      urlIdentifier: isSet(object.urlIdentifier) ? globalThis.String(object.urlIdentifier) : undefined,
      companyCode: isSet(object.companyCode) ? globalThis.String(object.companyCode) : undefined,
      surveillanceIndicator: isSet(object.surveillanceIndicator)
        ? globalThis.Number(object.surveillanceIndicator)
        : undefined,
      surveillanceIndicatorText: isSet(object.surveillanceIndicatorText)
        ? globalThis.String(object.surveillanceIndicatorText)
        : undefined,
      partOfCAS: isSet(object.partOfCAS) ? globalThis.Boolean(object.partOfCAS) : undefined,
      tradeable: isSet(object.tradeable) ? globalThis.Boolean(object.tradeable) : undefined,
    };
  },

  toJSON(message: Security): unknown {
    const obj: any = {};
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange);
    }
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.segment !== undefined) {
      obj.segment = segmentToJSON(message.segment);
    }
    if (message.symbol !== undefined) {
      obj.symbol = message.symbol;
    }
    if (message.exchangeSymbol !== undefined) {
      obj.exchangeSymbol = message.exchangeSymbol;
    }
    if (message.displayName !== undefined) {
      obj.displayName = message.displayName;
    }
    if (message.series !== undefined) {
      obj.series = message.series;
    }
    if (message.priceMultiplier !== undefined) {
      obj.priceMultiplier = Math.round(message.priceMultiplier);
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.logoUrl !== undefined) {
      obj.logoUrl = message.logoUrl;
    }
    if (message.underlyingSecurityCode !== undefined) {
      obj.underlyingSecurityCode = message.underlyingSecurityCode;
    }
    if (message.categoryCode !== undefined) {
      obj.categoryCode = securityCategory_CategoryCodeToJSON(message.categoryCode);
    }
    if (message.hasFo !== undefined) {
      obj.hasFo = message.hasFo;
    }
    if (message.lotSize !== undefined) {
      obj.lotSize = Math.round(message.lotSize);
    }
    if (message.volumeFreezeQuantity !== undefined) {
      obj.volumeFreezeQuantity = Math.round(message.volumeFreezeQuantity);
    }
    if (message.tickSize !== undefined) {
      obj.tickSize = Math.round(message.tickSize);
    }
    if (message.instrument !== undefined) {
      obj.instrument = message.instrument;
    }
    if (message.strikePrice !== undefined) {
      obj.strikePrice = Math.round(message.strikePrice);
    }
    if (message.optionType !== undefined) {
      obj.optionType = optionTypeToJSON(message.optionType);
    }
    if (message.expiry !== undefined) {
      obj.expiry = Expiry.toJSON(message.expiry);
    }
    if (message.derived !== undefined) {
      obj.derived = message.derived;
    }
    if (message.urlIdentifier !== undefined) {
      obj.urlIdentifier = message.urlIdentifier;
    }
    if (message.companyCode !== undefined) {
      obj.companyCode = message.companyCode;
    }
    if (message.surveillanceIndicator !== undefined) {
      obj.surveillanceIndicator = Math.round(message.surveillanceIndicator);
    }
    if (message.surveillanceIndicatorText !== undefined) {
      obj.surveillanceIndicatorText = message.surveillanceIndicatorText;
    }
    if (message.partOfCAS !== undefined) {
      obj.partOfCAS = message.partOfCAS;
    }
    if (message.tradeable !== undefined) {
      obj.tradeable = message.tradeable;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Security>, I>>(base?: I): Security {
    return Security.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Security>, I>>(object: I): Security {
    const message = createBaseSecurity();
    message.exchange = object.exchange ?? 0;
    message.code = object.code ?? "";
    message.segment = object.segment ?? undefined;
    message.symbol = object.symbol ?? undefined;
    message.exchangeSymbol = object.exchangeSymbol ?? undefined;
    message.displayName = object.displayName ?? undefined;
    message.series = object.series ?? undefined;
    message.priceMultiplier = object.priceMultiplier ?? undefined;
    message.name = object.name ?? undefined;
    message.logoUrl = object.logoUrl ?? undefined;
    message.underlyingSecurityCode = object.underlyingSecurityCode ?? undefined;
    message.categoryCode = object.categoryCode ?? undefined;
    message.hasFo = object.hasFo ?? undefined;
    message.lotSize = object.lotSize ?? undefined;
    message.volumeFreezeQuantity = object.volumeFreezeQuantity ?? undefined;
    message.tickSize = object.tickSize ?? undefined;
    message.instrument = object.instrument ?? undefined;
    message.strikePrice = object.strikePrice ?? undefined;
    message.optionType = object.optionType ?? undefined;
    message.expiry = (object.expiry !== undefined && object.expiry !== null)
      ? Expiry.fromPartial(object.expiry)
      : undefined;
    message.derived = object.derived ?? undefined;
    message.urlIdentifier = object.urlIdentifier ?? undefined;
    message.companyCode = object.companyCode ?? undefined;
    message.surveillanceIndicator = object.surveillanceIndicator ?? undefined;
    message.surveillanceIndicatorText = object.surveillanceIndicatorText ?? undefined;
    message.partOfCAS = object.partOfCAS ?? undefined;
    message.tradeable = object.tradeable ?? undefined;
    return message;
  },
};

function createBaseDerivedSecurity(): DerivedSecurity {
  return { security: undefined, referencedSecurity: undefined };
}

export const DerivedSecurity = {
  encode(message: DerivedSecurity, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(10).fork()).ldelim();
    }
    if (message.referencedSecurity !== undefined) {
      Security.encode(message.referencedSecurity, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DerivedSecurity {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDerivedSecurity();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.referencedSecurity = Security.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DerivedSecurity {
    return {
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      referencedSecurity: isSet(object.referencedSecurity) ? Security.fromJSON(object.referencedSecurity) : undefined,
    };
  },

  toJSON(message: DerivedSecurity): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.referencedSecurity !== undefined) {
      obj.referencedSecurity = Security.toJSON(message.referencedSecurity);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DerivedSecurity>, I>>(base?: I): DerivedSecurity {
    return DerivedSecurity.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DerivedSecurity>, I>>(object: I): DerivedSecurity {
    const message = createBaseDerivedSecurity();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.referencedSecurity = (object.referencedSecurity !== undefined && object.referencedSecurity !== null)
      ? Security.fromPartial(object.referencedSecurity)
      : undefined;
    return message;
  },
};

function createBaseSecurityExpression(): SecurityExpression {
  return { id: "", expression: "", name: "", securities: [], expired: false };
}

export const SecurityExpression = {
  encode(message: SecurityExpression, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.expression !== "") {
      writer.uint32(18).string(message.expression);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    for (const v of message.securities) {
      Security.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    if (message.expired !== false) {
      writer.uint32(40).bool(message.expired);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SecurityExpression {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSecurityExpression();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.expression = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.securities.push(Security.decode(reader, reader.uint32()));
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.expired = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SecurityExpression {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      expression: isSet(object.expression) ? globalThis.String(object.expression) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      securities: globalThis.Array.isArray(object?.securities)
        ? object.securities.map((e: any) => Security.fromJSON(e))
        : [],
      expired: isSet(object.expired) ? globalThis.Boolean(object.expired) : false,
    };
  },

  toJSON(message: SecurityExpression): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.expression !== "") {
      obj.expression = message.expression;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.securities?.length) {
      obj.securities = message.securities.map((e) => Security.toJSON(e));
    }
    if (message.expired !== false) {
      obj.expired = message.expired;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SecurityExpression>, I>>(base?: I): SecurityExpression {
    return SecurityExpression.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SecurityExpression>, I>>(object: I): SecurityExpression {
    const message = createBaseSecurityExpression();
    message.id = object.id ?? "";
    message.expression = object.expression ?? "";
    message.name = object.name ?? "";
    message.securities = object.securities?.map((e) => Security.fromPartial(e)) || [];
    message.expired = object.expired ?? false;
    return message;
  },
};

function createBaseSecurityCategories(): SecurityCategories {
  return { categories: [] };
}

export const SecurityCategories = {
  encode(message: SecurityCategories, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.categories) {
      SecurityCategory.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SecurityCategories {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSecurityCategories();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.categories.push(SecurityCategory.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SecurityCategories {
    return {
      categories: globalThis.Array.isArray(object?.categories)
        ? object.categories.map((e: any) => SecurityCategory.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SecurityCategories): unknown {
    const obj: any = {};
    if (message.categories?.length) {
      obj.categories = message.categories.map((e) => SecurityCategory.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SecurityCategories>, I>>(base?: I): SecurityCategories {
    return SecurityCategories.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SecurityCategories>, I>>(object: I): SecurityCategories {
    const message = createBaseSecurityCategories();
    message.categories = object.categories?.map((e) => SecurityCategory.fromPartial(e)) || [];
    return message;
  },
};

function createBaseLookupSecuritiesBySymbolRequest(): LookupSecuritiesBySymbolRequest {
  return { securities: [] };
}

export const LookupSecuritiesBySymbolRequest = {
  encode(message: LookupSecuritiesBySymbolRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.securities) {
      LookupSecuritiesBySymbolRequest_Security.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): LookupSecuritiesBySymbolRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLookupSecuritiesBySymbolRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.securities.push(LookupSecuritiesBySymbolRequest_Security.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LookupSecuritiesBySymbolRequest {
    return {
      securities: globalThis.Array.isArray(object?.securities)
        ? object.securities.map((e: any) => LookupSecuritiesBySymbolRequest_Security.fromJSON(e))
        : [],
    };
  },

  toJSON(message: LookupSecuritiesBySymbolRequest): unknown {
    const obj: any = {};
    if (message.securities?.length) {
      obj.securities = message.securities.map((e) => LookupSecuritiesBySymbolRequest_Security.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LookupSecuritiesBySymbolRequest>, I>>(base?: I): LookupSecuritiesBySymbolRequest {
    return LookupSecuritiesBySymbolRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LookupSecuritiesBySymbolRequest>, I>>(
    object: I,
  ): LookupSecuritiesBySymbolRequest {
    const message = createBaseLookupSecuritiesBySymbolRequest();
    message.securities = object.securities?.map((e) => LookupSecuritiesBySymbolRequest_Security.fromPartial(e)) || [];
    return message;
  },
};

function createBaseLookupSecuritiesBySymbolRequest_Security(): LookupSecuritiesBySymbolRequest_Security {
  return { exchange: 0, symbol: "" };
}

export const LookupSecuritiesBySymbolRequest_Security = {
  encode(message: LookupSecuritiesBySymbolRequest_Security, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange);
    }
    if (message.symbol !== "") {
      writer.uint32(18).string(message.symbol);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): LookupSecuritiesBySymbolRequest_Security {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLookupSecuritiesBySymbolRequest_Security();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.exchange = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.symbol = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LookupSecuritiesBySymbolRequest_Security {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : "",
    };
  },

  toJSON(message: LookupSecuritiesBySymbolRequest_Security): unknown {
    const obj: any = {};
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange);
    }
    if (message.symbol !== "") {
      obj.symbol = message.symbol;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LookupSecuritiesBySymbolRequest_Security>, I>>(
    base?: I,
  ): LookupSecuritiesBySymbolRequest_Security {
    return LookupSecuritiesBySymbolRequest_Security.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LookupSecuritiesBySymbolRequest_Security>, I>>(
    object: I,
  ): LookupSecuritiesBySymbolRequest_Security {
    const message = createBaseLookupSecuritiesBySymbolRequest_Security();
    message.exchange = object.exchange ?? 0;
    message.symbol = object.symbol ?? "";
    return message;
  },
};

function createBaseLookupSecuritiesBySymbolResponse(): LookupSecuritiesBySymbolResponse {
  return { securities: [] };
}

export const LookupSecuritiesBySymbolResponse = {
  encode(message: LookupSecuritiesBySymbolResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.securities) {
      Security.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): LookupSecuritiesBySymbolResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLookupSecuritiesBySymbolResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.securities.push(Security.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LookupSecuritiesBySymbolResponse {
    return {
      securities: globalThis.Array.isArray(object?.securities)
        ? object.securities.map((e: any) => Security.fromJSON(e))
        : [],
    };
  },

  toJSON(message: LookupSecuritiesBySymbolResponse): unknown {
    const obj: any = {};
    if (message.securities?.length) {
      obj.securities = message.securities.map((e) => Security.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LookupSecuritiesBySymbolResponse>, I>>(
    base?: I,
  ): LookupSecuritiesBySymbolResponse {
    return LookupSecuritiesBySymbolResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LookupSecuritiesBySymbolResponse>, I>>(
    object: I,
  ): LookupSecuritiesBySymbolResponse {
    const message = createBaseLookupSecuritiesBySymbolResponse();
    message.securities = object.securities?.map((e) => Security.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSearchSecurityRequest(): SearchSecurityRequest {
  return {
    searchText: "",
    exchange: 0,
    categoryCode: 0,
    pageNumber: 0,
    pageSize: 0,
    hasFo: undefined,
    instrument: undefined,
  };
}

export const SearchSecurityRequest = {
  encode(message: SearchSecurityRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.searchText !== "") {
      writer.uint32(10).string(message.searchText);
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange);
    }
    if (message.categoryCode !== 0) {
      writer.uint32(32).int32(message.categoryCode);
    }
    if (message.pageNumber !== 0) {
      writer.uint32(48).int32(message.pageNumber);
    }
    if (message.pageSize !== 0) {
      writer.uint32(56).int32(message.pageSize);
    }
    if (message.hasFo !== undefined) {
      writer.uint32(64).bool(message.hasFo);
    }
    if (message.instrument !== undefined) {
      writer.uint32(74).string(message.instrument);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SearchSecurityRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSearchSecurityRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.searchText = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.exchange = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.categoryCode = reader.int32() as any;
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.pageNumber = reader.int32();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.pageSize = reader.int32();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.hasFo = reader.bool();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.instrument = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SearchSecurityRequest {
    return {
      searchText: isSet(object.searchText) ? globalThis.String(object.searchText) : "",
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      categoryCode: isSet(object.categoryCode) ? securityCategory_CategoryCodeFromJSON(object.categoryCode) : 0,
      pageNumber: isSet(object.pageNumber) ? globalThis.Number(object.pageNumber) : 0,
      pageSize: isSet(object.pageSize) ? globalThis.Number(object.pageSize) : 0,
      hasFo: isSet(object.hasFo) ? globalThis.Boolean(object.hasFo) : undefined,
      instrument: isSet(object.instrument) ? globalThis.String(object.instrument) : undefined,
    };
  },

  toJSON(message: SearchSecurityRequest): unknown {
    const obj: any = {};
    if (message.searchText !== "") {
      obj.searchText = message.searchText;
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange);
    }
    if (message.categoryCode !== 0) {
      obj.categoryCode = securityCategory_CategoryCodeToJSON(message.categoryCode);
    }
    if (message.pageNumber !== 0) {
      obj.pageNumber = Math.round(message.pageNumber);
    }
    if (message.pageSize !== 0) {
      obj.pageSize = Math.round(message.pageSize);
    }
    if (message.hasFo !== undefined) {
      obj.hasFo = message.hasFo;
    }
    if (message.instrument !== undefined) {
      obj.instrument = message.instrument;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SearchSecurityRequest>, I>>(base?: I): SearchSecurityRequest {
    return SearchSecurityRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SearchSecurityRequest>, I>>(object: I): SearchSecurityRequest {
    const message = createBaseSearchSecurityRequest();
    message.searchText = object.searchText ?? "";
    message.exchange = object.exchange ?? 0;
    message.categoryCode = object.categoryCode ?? 0;
    message.pageNumber = object.pageNumber ?? 0;
    message.pageSize = object.pageSize ?? 0;
    message.hasFo = object.hasFo ?? undefined;
    message.instrument = object.instrument ?? undefined;
    return message;
  },
};

function createBaseSearchSecurityResponse(): SearchSecurityResponse {
  return { searchText: "", securitySearchItems: [], totalCount: 0 };
}

export const SearchSecurityResponse = {
  encode(message: SearchSecurityResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.searchText !== "") {
      writer.uint32(10).string(message.searchText);
    }
    for (const v of message.securitySearchItems) {
      SearchSecurityResponse_SecuritySearchItem.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    if (message.totalCount !== 0) {
      writer.uint32(24).int32(message.totalCount);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SearchSecurityResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSearchSecurityResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.searchText = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.securitySearchItems.push(SearchSecurityResponse_SecuritySearchItem.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.totalCount = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SearchSecurityResponse {
    return {
      searchText: isSet(object.searchText) ? globalThis.String(object.searchText) : "",
      securitySearchItems: globalThis.Array.isArray(object?.securitySearchItems)
        ? object.securitySearchItems.map((e: any) => SearchSecurityResponse_SecuritySearchItem.fromJSON(e))
        : [],
      totalCount: isSet(object.totalCount) ? globalThis.Number(object.totalCount) : 0,
    };
  },

  toJSON(message: SearchSecurityResponse): unknown {
    const obj: any = {};
    if (message.searchText !== "") {
      obj.searchText = message.searchText;
    }
    if (message.securitySearchItems?.length) {
      obj.securitySearchItems = message.securitySearchItems.map((e) =>
        SearchSecurityResponse_SecuritySearchItem.toJSON(e)
      );
    }
    if (message.totalCount !== 0) {
      obj.totalCount = Math.round(message.totalCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SearchSecurityResponse>, I>>(base?: I): SearchSecurityResponse {
    return SearchSecurityResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SearchSecurityResponse>, I>>(object: I): SearchSecurityResponse {
    const message = createBaseSearchSecurityResponse();
    message.searchText = object.searchText ?? "";
    message.securitySearchItems =
      object.securitySearchItems?.map((e) => SearchSecurityResponse_SecuritySearchItem.fromPartial(e)) || [];
    message.totalCount = object.totalCount ?? 0;
    return message;
  },
};

function createBaseSearchSecurityResponse_Security(): SearchSecurityResponse_Security {
  return {
    exchange: 0,
    code: "",
    symbol: undefined,
    displayName: undefined,
    series: undefined,
    priceMultiplier: undefined,
    categoryCode: undefined,
    logoUrl: undefined,
    instrument: undefined,
  };
}

export const SearchSecurityResponse_Security = {
  encode(message: SearchSecurityResponse_Security, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange);
    }
    if (message.code !== "") {
      writer.uint32(18).string(message.code);
    }
    if (message.symbol !== undefined) {
      writer.uint32(34).string(message.symbol);
    }
    if (message.displayName !== undefined) {
      writer.uint32(50).string(message.displayName);
    }
    if (message.series !== undefined) {
      writer.uint32(58).string(message.series);
    }
    if (message.priceMultiplier !== undefined) {
      writer.uint32(64).int32(message.priceMultiplier);
    }
    if (message.categoryCode !== undefined) {
      writer.uint32(72).int32(message.categoryCode);
    }
    if (message.logoUrl !== undefined) {
      writer.uint32(82).string(message.logoUrl);
    }
    if (message.instrument !== undefined) {
      writer.uint32(90).string(message.instrument);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SearchSecurityResponse_Security {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSearchSecurityResponse_Security();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.exchange = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.code = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.symbol = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.displayName = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.series = reader.string();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.priceMultiplier = reader.int32();
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.categoryCode = reader.int32() as any;
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.logoUrl = reader.string();
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.instrument = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SearchSecurityResponse_Security {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : undefined,
      displayName: isSet(object.displayName) ? globalThis.String(object.displayName) : undefined,
      series: isSet(object.series) ? globalThis.String(object.series) : undefined,
      priceMultiplier: isSet(object.priceMultiplier) ? globalThis.Number(object.priceMultiplier) : undefined,
      categoryCode: isSet(object.categoryCode) ? securityCategory_CategoryCodeFromJSON(object.categoryCode) : undefined,
      logoUrl: isSet(object.logoUrl) ? globalThis.String(object.logoUrl) : undefined,
      instrument: isSet(object.instrument) ? globalThis.String(object.instrument) : undefined,
    };
  },

  toJSON(message: SearchSecurityResponse_Security): unknown {
    const obj: any = {};
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange);
    }
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.symbol !== undefined) {
      obj.symbol = message.symbol;
    }
    if (message.displayName !== undefined) {
      obj.displayName = message.displayName;
    }
    if (message.series !== undefined) {
      obj.series = message.series;
    }
    if (message.priceMultiplier !== undefined) {
      obj.priceMultiplier = Math.round(message.priceMultiplier);
    }
    if (message.categoryCode !== undefined) {
      obj.categoryCode = securityCategory_CategoryCodeToJSON(message.categoryCode);
    }
    if (message.logoUrl !== undefined) {
      obj.logoUrl = message.logoUrl;
    }
    if (message.instrument !== undefined) {
      obj.instrument = message.instrument;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SearchSecurityResponse_Security>, I>>(base?: I): SearchSecurityResponse_Security {
    return SearchSecurityResponse_Security.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SearchSecurityResponse_Security>, I>>(
    object: I,
  ): SearchSecurityResponse_Security {
    const message = createBaseSearchSecurityResponse_Security();
    message.exchange = object.exchange ?? 0;
    message.code = object.code ?? "";
    message.symbol = object.symbol ?? undefined;
    message.displayName = object.displayName ?? undefined;
    message.series = object.series ?? undefined;
    message.priceMultiplier = object.priceMultiplier ?? undefined;
    message.categoryCode = object.categoryCode ?? undefined;
    message.logoUrl = object.logoUrl ?? undefined;
    message.instrument = object.instrument ?? undefined;
    return message;
  },
};

function createBaseSearchSecurityResponse_SecuritySearchItem(): SearchSecurityResponse_SecuritySearchItem {
  return { isExpression: false, expression: undefined, securities: [] };
}

export const SearchSecurityResponse_SecuritySearchItem = {
  encode(message: SearchSecurityResponse_SecuritySearchItem, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.isExpression !== false) {
      writer.uint32(8).bool(message.isExpression);
    }
    if (message.expression !== undefined) {
      SecurityExpression.encode(message.expression, writer.uint32(18).fork()).ldelim();
    }
    for (const v of message.securities) {
      SearchSecurityResponse_Security.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SearchSecurityResponse_SecuritySearchItem {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSearchSecurityResponse_SecuritySearchItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.isExpression = reader.bool();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.expression = SecurityExpression.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.securities.push(SearchSecurityResponse_Security.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SearchSecurityResponse_SecuritySearchItem {
    return {
      isExpression: isSet(object.isExpression) ? globalThis.Boolean(object.isExpression) : false,
      expression: isSet(object.expression) ? SecurityExpression.fromJSON(object.expression) : undefined,
      securities: globalThis.Array.isArray(object?.securities)
        ? object.securities.map((e: any) => SearchSecurityResponse_Security.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SearchSecurityResponse_SecuritySearchItem): unknown {
    const obj: any = {};
    if (message.isExpression !== false) {
      obj.isExpression = message.isExpression;
    }
    if (message.expression !== undefined) {
      obj.expression = SecurityExpression.toJSON(message.expression);
    }
    if (message.securities?.length) {
      obj.securities = message.securities.map((e) => SearchSecurityResponse_Security.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SearchSecurityResponse_SecuritySearchItem>, I>>(
    base?: I,
  ): SearchSecurityResponse_SecuritySearchItem {
    return SearchSecurityResponse_SecuritySearchItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SearchSecurityResponse_SecuritySearchItem>, I>>(
    object: I,
  ): SearchSecurityResponse_SecuritySearchItem {
    const message = createBaseSearchSecurityResponse_SecuritySearchItem();
    message.isExpression = object.isExpression ?? false;
    message.expression = (object.expression !== undefined && object.expression !== null)
      ? SecurityExpression.fromPartial(object.expression)
      : undefined;
    message.securities = object.securities?.map((e) => SearchSecurityResponse_Security.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSecuritySnapshots(): SecuritySnapshots {
  return { securitySnapshots: [] };
}

export const SecuritySnapshots = {
  encode(message: SecuritySnapshots, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.securitySnapshots) {
      SecuritySnapshot.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SecuritySnapshots {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSecuritySnapshots();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.securitySnapshots.push(SecuritySnapshot.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SecuritySnapshots {
    return {
      securitySnapshots: globalThis.Array.isArray(object?.securitySnapshots)
        ? object.securitySnapshots.map((e: any) => SecuritySnapshot.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SecuritySnapshots): unknown {
    const obj: any = {};
    if (message.securitySnapshots?.length) {
      obj.securitySnapshots = message.securitySnapshots.map((e) => SecuritySnapshot.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SecuritySnapshots>, I>>(base?: I): SecuritySnapshots {
    return SecuritySnapshots.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SecuritySnapshots>, I>>(object: I): SecuritySnapshots {
    const message = createBaseSecuritySnapshots();
    message.securitySnapshots = object.securitySnapshots?.map((e) => SecuritySnapshot.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSecuritySnapshot(): SecuritySnapshot {
  return {
    security: undefined,
    lastTradedPrice: 0,
    volume: 0,
    previousClose: 0,
    lastTradedTime: 0,
    referencedSecurity: undefined,
  };
}

export const SecuritySnapshot = {
  encode(message: SecuritySnapshot, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security1.encode(message.security, writer.uint32(10).fork()).ldelim();
    }
    if (message.lastTradedPrice !== 0) {
      writer.uint32(24).int32(message.lastTradedPrice);
    }
    if (message.volume !== 0) {
      writer.uint32(40).int64(message.volume);
    }
    if (message.previousClose !== 0) {
      writer.uint32(56).int32(message.previousClose);
    }
    if (message.lastTradedTime !== 0) {
      writer.uint32(72).int64(message.lastTradedTime);
    }
    if (message.referencedSecurity !== undefined) {
      Security1.encode(message.referencedSecurity, writer.uint32(98).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SecuritySnapshot {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSecuritySnapshot();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.security = Security1.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.lastTradedPrice = reader.int32();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.volume = longToNumber(reader.int64() as Long);
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.previousClose = reader.int32();
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.lastTradedTime = longToNumber(reader.int64() as Long);
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.referencedSecurity = Security1.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SecuritySnapshot {
    return {
      security: isSet(object.security) ? Security1.fromJSON(object.security) : undefined,
      lastTradedPrice: isSet(object.lastTradedPrice) ? globalThis.Number(object.lastTradedPrice) : 0,
      volume: isSet(object.volume) ? globalThis.Number(object.volume) : 0,
      previousClose: isSet(object.previousClose) ? globalThis.Number(object.previousClose) : 0,
      lastTradedTime: isSet(object.lastTradedTime) ? globalThis.Number(object.lastTradedTime) : 0,
      referencedSecurity: isSet(object.referencedSecurity) ? Security1.fromJSON(object.referencedSecurity) : undefined,
    };
  },

  toJSON(message: SecuritySnapshot): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security1.toJSON(message.security);
    }
    if (message.lastTradedPrice !== 0) {
      obj.lastTradedPrice = Math.round(message.lastTradedPrice);
    }
    if (message.volume !== 0) {
      obj.volume = Math.round(message.volume);
    }
    if (message.previousClose !== 0) {
      obj.previousClose = Math.round(message.previousClose);
    }
    if (message.lastTradedTime !== 0) {
      obj.lastTradedTime = Math.round(message.lastTradedTime);
    }
    if (message.referencedSecurity !== undefined) {
      obj.referencedSecurity = Security1.toJSON(message.referencedSecurity);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SecuritySnapshot>, I>>(base?: I): SecuritySnapshot {
    return SecuritySnapshot.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SecuritySnapshot>, I>>(object: I): SecuritySnapshot {
    const message = createBaseSecuritySnapshot();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security1.fromPartial(object.security)
      : undefined;
    message.lastTradedPrice = object.lastTradedPrice ?? 0;
    message.volume = object.volume ?? 0;
    message.previousClose = object.previousClose ?? 0;
    message.lastTradedTime = object.lastTradedTime ?? 0;
    message.referencedSecurity = (object.referencedSecurity !== undefined && object.referencedSecurity !== null)
      ? Security1.fromPartial(object.referencedSecurity)
      : undefined;
    return message;
  },
};

function createBaseOrderBooks(): OrderBooks {
  return { orderBooks: [] };
}

export const OrderBooks = {
  encode(message: OrderBooks, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.orderBooks) {
      OrderBook.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OrderBooks {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrderBooks();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.orderBooks.push(OrderBook.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrderBooks {
    return {
      orderBooks: globalThis.Array.isArray(object?.orderBooks)
        ? object.orderBooks.map((e: any) => OrderBook.fromJSON(e))
        : [],
    };
  },

  toJSON(message: OrderBooks): unknown {
    const obj: any = {};
    if (message.orderBooks?.length) {
      obj.orderBooks = message.orderBooks.map((e) => OrderBook.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrderBooks>, I>>(base?: I): OrderBooks {
    return OrderBooks.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrderBooks>, I>>(object: I): OrderBooks {
    const message = createBaseOrderBooks();
    message.orderBooks = object.orderBooks?.map((e) => OrderBook.fromPartial(e)) || [];
    return message;
  },
};

function createBaseOrderBook(): OrderBook {
  return {
    security: undefined,
    lastTradedTime: 0,
    lastTradedPrice: 0,
    volumeTradedToday: 0,
    totalBuyQuantity: 0,
    totalSellQuantity: 0,
    open: 0,
    high: 0,
    low: 0,
    close: 0,
    timestamp: 0,
    lowerCircuit: 0,
    upperCircuit: 0,
    bids: [],
    asks: [],
    referencedSecurity: undefined,
    lastTradedQuantity: 0,
    averageTradedPrice: 0,
    session: 0,
    auction: undefined,
    openInterest: undefined,
    inav: undefined,
  };
}

export const OrderBook = {
  encode(message: OrderBook, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security1.encode(message.security, writer.uint32(10).fork()).ldelim();
    }
    if (message.lastTradedTime !== 0) {
      writer.uint32(32).int64(message.lastTradedTime);
    }
    if (message.lastTradedPrice !== 0) {
      writer.uint32(40).int32(message.lastTradedPrice);
    }
    if (message.volumeTradedToday !== 0) {
      writer.uint32(48).int32(message.volumeTradedToday);
    }
    if (message.totalBuyQuantity !== 0) {
      writer.uint32(56).int64(message.totalBuyQuantity);
    }
    if (message.totalSellQuantity !== 0) {
      writer.uint32(64).int64(message.totalSellQuantity);
    }
    if (message.open !== 0) {
      writer.uint32(72).int32(message.open);
    }
    if (message.high !== 0) {
      writer.uint32(80).int32(message.high);
    }
    if (message.low !== 0) {
      writer.uint32(88).int32(message.low);
    }
    if (message.close !== 0) {
      writer.uint32(96).int32(message.close);
    }
    if (message.timestamp !== 0) {
      writer.uint32(104).int64(message.timestamp);
    }
    if (message.lowerCircuit !== 0) {
      writer.uint32(112).int32(message.lowerCircuit);
    }
    if (message.upperCircuit !== 0) {
      writer.uint32(120).int32(message.upperCircuit);
    }
    for (const v of message.bids) {
      OrderBook_OrderBookQuote.encode(v!, writer.uint32(130).fork()).ldelim();
    }
    for (const v of message.asks) {
      OrderBook_OrderBookQuote.encode(v!, writer.uint32(138).fork()).ldelim();
    }
    if (message.referencedSecurity !== undefined) {
      Security1.encode(message.referencedSecurity, writer.uint32(162).fork()).ldelim();
    }
    if (message.lastTradedQuantity !== 0) {
      writer.uint32(168).int64(message.lastTradedQuantity);
    }
    if (message.averageTradedPrice !== 0) {
      writer.uint32(176).int64(message.averageTradedPrice);
    }
    if (message.session !== 0) {
      writer.uint32(184).int32(message.session);
    }
    if (message.auction !== undefined) {
      OrderBook_AuctionState.encode(message.auction, writer.uint32(194).fork()).ldelim();
    }
    if (message.openInterest !== undefined) {
      writer.uint32(200).int64(message.openInterest);
    }
    if (message.inav !== undefined) {
      writer.uint32(208).int32(message.inav);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OrderBook {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrderBook();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.security = Security1.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.lastTradedTime = longToNumber(reader.int64() as Long);
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.lastTradedPrice = reader.int32();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.volumeTradedToday = reader.int32();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.totalBuyQuantity = longToNumber(reader.int64() as Long);
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.totalSellQuantity = longToNumber(reader.int64() as Long);
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.open = reader.int32();
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.high = reader.int32();
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.low = reader.int32();
          continue;
        case 12:
          if (tag !== 96) {
            break;
          }

          message.close = reader.int32();
          continue;
        case 13:
          if (tag !== 104) {
            break;
          }

          message.timestamp = longToNumber(reader.int64() as Long);
          continue;
        case 14:
          if (tag !== 112) {
            break;
          }

          message.lowerCircuit = reader.int32();
          continue;
        case 15:
          if (tag !== 120) {
            break;
          }

          message.upperCircuit = reader.int32();
          continue;
        case 16:
          if (tag !== 130) {
            break;
          }

          message.bids.push(OrderBook_OrderBookQuote.decode(reader, reader.uint32()));
          continue;
        case 17:
          if (tag !== 138) {
            break;
          }

          message.asks.push(OrderBook_OrderBookQuote.decode(reader, reader.uint32()));
          continue;
        case 20:
          if (tag !== 162) {
            break;
          }

          message.referencedSecurity = Security1.decode(reader, reader.uint32());
          continue;
        case 21:
          if (tag !== 168) {
            break;
          }

          message.lastTradedQuantity = longToNumber(reader.int64() as Long);
          continue;
        case 22:
          if (tag !== 176) {
            break;
          }

          message.averageTradedPrice = longToNumber(reader.int64() as Long);
          continue;
        case 23:
          if (tag !== 184) {
            break;
          }

          message.session = reader.int32() as any;
          continue;
        case 24:
          if (tag !== 194) {
            break;
          }

          message.auction = OrderBook_AuctionState.decode(reader, reader.uint32());
          continue;
        case 25:
          if (tag !== 200) {
            break;
          }

          message.openInterest = longToNumber(reader.int64() as Long);
          continue;
        case 26:
          if (tag !== 208) {
            break;
          }

          message.inav = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrderBook {
    return {
      security: isSet(object.security) ? Security1.fromJSON(object.security) : undefined,
      lastTradedTime: isSet(object.lastTradedTime) ? globalThis.Number(object.lastTradedTime) : 0,
      lastTradedPrice: isSet(object.lastTradedPrice) ? globalThis.Number(object.lastTradedPrice) : 0,
      volumeTradedToday: isSet(object.volumeTradedToday) ? globalThis.Number(object.volumeTradedToday) : 0,
      totalBuyQuantity: isSet(object.totalBuyQuantity) ? globalThis.Number(object.totalBuyQuantity) : 0,
      totalSellQuantity: isSet(object.totalSellQuantity) ? globalThis.Number(object.totalSellQuantity) : 0,
      open: isSet(object.open) ? globalThis.Number(object.open) : 0,
      high: isSet(object.high) ? globalThis.Number(object.high) : 0,
      low: isSet(object.low) ? globalThis.Number(object.low) : 0,
      close: isSet(object.close) ? globalThis.Number(object.close) : 0,
      timestamp: isSet(object.timestamp) ? globalThis.Number(object.timestamp) : 0,
      lowerCircuit: isSet(object.lowerCircuit) ? globalThis.Number(object.lowerCircuit) : 0,
      upperCircuit: isSet(object.upperCircuit) ? globalThis.Number(object.upperCircuit) : 0,
      bids: globalThis.Array.isArray(object?.bids)
        ? object.bids.map((e: any) => OrderBook_OrderBookQuote.fromJSON(e))
        : [],
      asks: globalThis.Array.isArray(object?.asks)
        ? object.asks.map((e: any) => OrderBook_OrderBookQuote.fromJSON(e))
        : [],
      referencedSecurity: isSet(object.referencedSecurity) ? Security1.fromJSON(object.referencedSecurity) : undefined,
      lastTradedQuantity: isSet(object.lastTradedQuantity) ? globalThis.Number(object.lastTradedQuantity) : 0,
      averageTradedPrice: isSet(object.averageTradedPrice) ? globalThis.Number(object.averageTradedPrice) : 0,
      session: isSet(object.session) ? orderBook_SessionFromJSON(object.session) : 0,
      auction: isSet(object.auction) ? OrderBook_AuctionState.fromJSON(object.auction) : undefined,
      openInterest: isSet(object.openInterest) ? globalThis.Number(object.openInterest) : undefined,
      inav: isSet(object.inav) ? globalThis.Number(object.inav) : undefined,
    };
  },

  toJSON(message: OrderBook): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security1.toJSON(message.security);
    }
    if (message.lastTradedTime !== 0) {
      obj.lastTradedTime = Math.round(message.lastTradedTime);
    }
    if (message.lastTradedPrice !== 0) {
      obj.lastTradedPrice = Math.round(message.lastTradedPrice);
    }
    if (message.volumeTradedToday !== 0) {
      obj.volumeTradedToday = Math.round(message.volumeTradedToday);
    }
    if (message.totalBuyQuantity !== 0) {
      obj.totalBuyQuantity = Math.round(message.totalBuyQuantity);
    }
    if (message.totalSellQuantity !== 0) {
      obj.totalSellQuantity = Math.round(message.totalSellQuantity);
    }
    if (message.open !== 0) {
      obj.open = Math.round(message.open);
    }
    if (message.high !== 0) {
      obj.high = Math.round(message.high);
    }
    if (message.low !== 0) {
      obj.low = Math.round(message.low);
    }
    if (message.close !== 0) {
      obj.close = Math.round(message.close);
    }
    if (message.timestamp !== 0) {
      obj.timestamp = Math.round(message.timestamp);
    }
    if (message.lowerCircuit !== 0) {
      obj.lowerCircuit = Math.round(message.lowerCircuit);
    }
    if (message.upperCircuit !== 0) {
      obj.upperCircuit = Math.round(message.upperCircuit);
    }
    if (message.bids?.length) {
      obj.bids = message.bids.map((e) => OrderBook_OrderBookQuote.toJSON(e));
    }
    if (message.asks?.length) {
      obj.asks = message.asks.map((e) => OrderBook_OrderBookQuote.toJSON(e));
    }
    if (message.referencedSecurity !== undefined) {
      obj.referencedSecurity = Security1.toJSON(message.referencedSecurity);
    }
    if (message.lastTradedQuantity !== 0) {
      obj.lastTradedQuantity = Math.round(message.lastTradedQuantity);
    }
    if (message.averageTradedPrice !== 0) {
      obj.averageTradedPrice = Math.round(message.averageTradedPrice);
    }
    if (message.session !== 0) {
      obj.session = orderBook_SessionToJSON(message.session);
    }
    if (message.auction !== undefined) {
      obj.auction = OrderBook_AuctionState.toJSON(message.auction);
    }
    if (message.openInterest !== undefined) {
      obj.openInterest = Math.round(message.openInterest);
    }
    if (message.inav !== undefined) {
      obj.inav = Math.round(message.inav);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrderBook>, I>>(base?: I): OrderBook {
    return OrderBook.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrderBook>, I>>(object: I): OrderBook {
    const message = createBaseOrderBook();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security1.fromPartial(object.security)
      : undefined;
    message.lastTradedTime = object.lastTradedTime ?? 0;
    message.lastTradedPrice = object.lastTradedPrice ?? 0;
    message.volumeTradedToday = object.volumeTradedToday ?? 0;
    message.totalBuyQuantity = object.totalBuyQuantity ?? 0;
    message.totalSellQuantity = object.totalSellQuantity ?? 0;
    message.open = object.open ?? 0;
    message.high = object.high ?? 0;
    message.low = object.low ?? 0;
    message.close = object.close ?? 0;
    message.timestamp = object.timestamp ?? 0;
    message.lowerCircuit = object.lowerCircuit ?? 0;
    message.upperCircuit = object.upperCircuit ?? 0;
    message.bids = object.bids?.map((e) => OrderBook_OrderBookQuote.fromPartial(e)) || [];
    message.asks = object.asks?.map((e) => OrderBook_OrderBookQuote.fromPartial(e)) || [];
    message.referencedSecurity = (object.referencedSecurity !== undefined && object.referencedSecurity !== null)
      ? Security1.fromPartial(object.referencedSecurity)
      : undefined;
    message.lastTradedQuantity = object.lastTradedQuantity ?? 0;
    message.averageTradedPrice = object.averageTradedPrice ?? 0;
    message.session = object.session ?? 0;
    message.auction = (object.auction !== undefined && object.auction !== null)
      ? OrderBook_AuctionState.fromPartial(object.auction)
      : undefined;
    message.openInterest = object.openInterest ?? undefined;
    message.inav = object.inav ?? undefined;
    return message;
  },
};

function createBaseOrderBook_OrderBookQuote(): OrderBook_OrderBookQuote {
  return { price: 0, quantity: 0, numberOfOrders: 0 };
}

export const OrderBook_OrderBookQuote = {
  encode(message: OrderBook_OrderBookQuote, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.price !== 0) {
      writer.uint32(8).int32(message.price);
    }
    if (message.quantity !== 0) {
      writer.uint32(16).int32(message.quantity);
    }
    if (message.numberOfOrders !== 0) {
      writer.uint32(24).int32(message.numberOfOrders);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OrderBook_OrderBookQuote {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrderBook_OrderBookQuote();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.price = reader.int32();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.quantity = reader.int32();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.numberOfOrders = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrderBook_OrderBookQuote {
    return {
      price: isSet(object.price) ? globalThis.Number(object.price) : 0,
      quantity: isSet(object.quantity) ? globalThis.Number(object.quantity) : 0,
      numberOfOrders: isSet(object.numberOfOrders) ? globalThis.Number(object.numberOfOrders) : 0,
    };
  },

  toJSON(message: OrderBook_OrderBookQuote): unknown {
    const obj: any = {};
    if (message.price !== 0) {
      obj.price = Math.round(message.price);
    }
    if (message.quantity !== 0) {
      obj.quantity = Math.round(message.quantity);
    }
    if (message.numberOfOrders !== 0) {
      obj.numberOfOrders = Math.round(message.numberOfOrders);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrderBook_OrderBookQuote>, I>>(base?: I): OrderBook_OrderBookQuote {
    return OrderBook_OrderBookQuote.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrderBook_OrderBookQuote>, I>>(object: I): OrderBook_OrderBookQuote {
    const message = createBaseOrderBook_OrderBookQuote();
    message.price = object.price ?? 0;
    message.quantity = object.quantity ?? 0;
    message.numberOfOrders = object.numberOfOrders ?? 0;
    return message;
  },
};

function createBaseOrderBook_AuctionState(): OrderBook_AuctionState {
  return {
    indicativePrice: undefined,
    indicativeQuantity: undefined,
    totalImbalanceQuantity: undefined,
    marketImbalanceQuantity: undefined,
    referencePrice: undefined,
  };
}

export const OrderBook_AuctionState = {
  encode(message: OrderBook_AuctionState, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.indicativePrice !== undefined) {
      writer.uint32(8).int32(message.indicativePrice);
    }
    if (message.indicativeQuantity !== undefined) {
      writer.uint32(16).int64(message.indicativeQuantity);
    }
    if (message.totalImbalanceQuantity !== undefined) {
      writer.uint32(24).int64(message.totalImbalanceQuantity);
    }
    if (message.marketImbalanceQuantity !== undefined) {
      writer.uint32(32).int64(message.marketImbalanceQuantity);
    }
    if (message.referencePrice !== undefined) {
      writer.uint32(40).int32(message.referencePrice);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OrderBook_AuctionState {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrderBook_AuctionState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.indicativePrice = reader.int32();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.indicativeQuantity = longToNumber(reader.int64() as Long);
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.totalImbalanceQuantity = longToNumber(reader.int64() as Long);
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.marketImbalanceQuantity = longToNumber(reader.int64() as Long);
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.referencePrice = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrderBook_AuctionState {
    return {
      indicativePrice: isSet(object.indicativePrice) ? globalThis.Number(object.indicativePrice) : undefined,
      indicativeQuantity: isSet(object.indicativeQuantity) ? globalThis.Number(object.indicativeQuantity) : undefined,
      totalImbalanceQuantity: isSet(object.totalImbalanceQuantity)
        ? globalThis.Number(object.totalImbalanceQuantity)
        : undefined,
      marketImbalanceQuantity: isSet(object.marketImbalanceQuantity)
        ? globalThis.Number(object.marketImbalanceQuantity)
        : undefined,
      referencePrice: isSet(object.referencePrice) ? globalThis.Number(object.referencePrice) : undefined,
    };
  },

  toJSON(message: OrderBook_AuctionState): unknown {
    const obj: any = {};
    if (message.indicativePrice !== undefined) {
      obj.indicativePrice = Math.round(message.indicativePrice);
    }
    if (message.indicativeQuantity !== undefined) {
      obj.indicativeQuantity = Math.round(message.indicativeQuantity);
    }
    if (message.totalImbalanceQuantity !== undefined) {
      obj.totalImbalanceQuantity = Math.round(message.totalImbalanceQuantity);
    }
    if (message.marketImbalanceQuantity !== undefined) {
      obj.marketImbalanceQuantity = Math.round(message.marketImbalanceQuantity);
    }
    if (message.referencePrice !== undefined) {
      obj.referencePrice = Math.round(message.referencePrice);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrderBook_AuctionState>, I>>(base?: I): OrderBook_AuctionState {
    return OrderBook_AuctionState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrderBook_AuctionState>, I>>(object: I): OrderBook_AuctionState {
    const message = createBaseOrderBook_AuctionState();
    message.indicativePrice = object.indicativePrice ?? undefined;
    message.indicativeQuantity = object.indicativeQuantity ?? undefined;
    message.totalImbalanceQuantity = object.totalImbalanceQuantity ?? undefined;
    message.marketImbalanceQuantity = object.marketImbalanceQuantity ?? undefined;
    message.referencePrice = object.referencePrice ?? undefined;
    return message;
  },
};

function createBaseDataUpdateMessage(): DataUpdateMessage {
  return { type: 0, parameters: [] };
}

export const DataUpdateMessage = {
  encode(message: DataUpdateMessage, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    for (const v of message.parameters) {
      DataUpdateMessage_Parameter.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DataUpdateMessage {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDataUpdateMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.parameters.push(DataUpdateMessage_Parameter.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DataUpdateMessage {
    return {
      type: isSet(object.type) ? dataUpdateMessage_TypeFromJSON(object.type) : 0,
      parameters: globalThis.Array.isArray(object?.parameters)
        ? object.parameters.map((e: any) => DataUpdateMessage_Parameter.fromJSON(e))
        : [],
    };
  },

  toJSON(message: DataUpdateMessage): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = dataUpdateMessage_TypeToJSON(message.type);
    }
    if (message.parameters?.length) {
      obj.parameters = message.parameters.map((e) => DataUpdateMessage_Parameter.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DataUpdateMessage>, I>>(base?: I): DataUpdateMessage {
    return DataUpdateMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DataUpdateMessage>, I>>(object: I): DataUpdateMessage {
    const message = createBaseDataUpdateMessage();
    message.type = object.type ?? 0;
    message.parameters = object.parameters?.map((e) => DataUpdateMessage_Parameter.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDataUpdateMessage_Parameter(): DataUpdateMessage_Parameter {
  return { name: "", value: "" };
}

export const DataUpdateMessage_Parameter = {
  encode(message: DataUpdateMessage_Parameter, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DataUpdateMessage_Parameter {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDataUpdateMessage_Parameter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DataUpdateMessage_Parameter {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: DataUpdateMessage_Parameter): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DataUpdateMessage_Parameter>, I>>(base?: I): DataUpdateMessage_Parameter {
    return DataUpdateMessage_Parameter.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DataUpdateMessage_Parameter>, I>>(object: I): DataUpdateMessage_Parameter {
    const message = createBaseDataUpdateMessage_Parameter();
    message.name = object.name ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseFoProto(): FoProto {
  return { optionsSecurities: [], futuresSecurities: [], derivedSecurities: [] };
}

export const FoProto = {
  encode(message: FoProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.optionsSecurities) {
      FoProto_OptionSecurityProto.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    for (const v of message.futuresSecurities) {
      FoProto_FutureSecurityProto.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    for (const v of message.derivedSecurities) {
      FoProto_DerivedSecurityProto.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FoProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFoProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.optionsSecurities.push(FoProto_OptionSecurityProto.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.futuresSecurities.push(FoProto_FutureSecurityProto.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.derivedSecurities.push(FoProto_DerivedSecurityProto.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FoProto {
    return {
      optionsSecurities: globalThis.Array.isArray(object?.optionsSecurities)
        ? object.optionsSecurities.map((e: any) => FoProto_OptionSecurityProto.fromJSON(e))
        : [],
      futuresSecurities: globalThis.Array.isArray(object?.futuresSecurities)
        ? object.futuresSecurities.map((e: any) => FoProto_FutureSecurityProto.fromJSON(e))
        : [],
      derivedSecurities: globalThis.Array.isArray(object?.derivedSecurities)
        ? object.derivedSecurities.map((e: any) => FoProto_DerivedSecurityProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: FoProto): unknown {
    const obj: any = {};
    if (message.optionsSecurities?.length) {
      obj.optionsSecurities = message.optionsSecurities.map((e) => FoProto_OptionSecurityProto.toJSON(e));
    }
    if (message.futuresSecurities?.length) {
      obj.futuresSecurities = message.futuresSecurities.map((e) => FoProto_FutureSecurityProto.toJSON(e));
    }
    if (message.derivedSecurities?.length) {
      obj.derivedSecurities = message.derivedSecurities.map((e) => FoProto_DerivedSecurityProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FoProto>, I>>(base?: I): FoProto {
    return FoProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FoProto>, I>>(object: I): FoProto {
    const message = createBaseFoProto();
    message.optionsSecurities = object.optionsSecurities?.map((e) => FoProto_OptionSecurityProto.fromPartial(e)) || [];
    message.futuresSecurities = object.futuresSecurities?.map((e) => FoProto_FutureSecurityProto.fromPartial(e)) || [];
    message.derivedSecurities = object.derivedSecurities?.map((e) => FoProto_DerivedSecurityProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseFoProto_OptionSecurityProto(): FoProto_OptionSecurityProto {
  return {
    securityCodePrefix: "",
    symbolPrefix: undefined,
    displayNamePrefix: undefined,
    priceMultiplier: undefined,
    lotSize: undefined,
    volumeFreezeQuantity: undefined,
    tickSize: undefined,
    expiry: undefined,
    strikes: [],
    name: undefined,
  };
}

export const FoProto_OptionSecurityProto = {
  encode(message: FoProto_OptionSecurityProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.securityCodePrefix !== "") {
      writer.uint32(10).string(message.securityCodePrefix);
    }
    if (message.symbolPrefix !== undefined) {
      writer.uint32(18).string(message.symbolPrefix);
    }
    if (message.displayNamePrefix !== undefined) {
      writer.uint32(26).string(message.displayNamePrefix);
    }
    if (message.priceMultiplier !== undefined) {
      writer.uint32(32).int32(message.priceMultiplier);
    }
    if (message.lotSize !== undefined) {
      writer.uint32(40).int32(message.lotSize);
    }
    if (message.volumeFreezeQuantity !== undefined) {
      writer.uint32(48).int32(message.volumeFreezeQuantity);
    }
    if (message.tickSize !== undefined) {
      writer.uint32(56).int32(message.tickSize);
    }
    if (message.expiry !== undefined) {
      Expiry.encode(message.expiry, writer.uint32(66).fork()).ldelim();
    }
    writer.uint32(74).fork();
    for (const v of message.strikes) {
      writer.int32(v);
    }
    writer.ldelim();
    if (message.name !== undefined) {
      writer.uint32(82).string(message.name);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FoProto_OptionSecurityProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFoProto_OptionSecurityProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.securityCodePrefix = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.symbolPrefix = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.displayNamePrefix = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.priceMultiplier = reader.int32();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.lotSize = reader.int32();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.volumeFreezeQuantity = reader.int32();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.tickSize = reader.int32();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.expiry = Expiry.decode(reader, reader.uint32());
          continue;
        case 9:
          if (tag === 72) {
            message.strikes.push(reader.int32());

            continue;
          }

          if (tag === 74) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.strikes.push(reader.int32());
            }

            continue;
          }

          break;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.name = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FoProto_OptionSecurityProto {
    return {
      securityCodePrefix: isSet(object.securityCodePrefix) ? globalThis.String(object.securityCodePrefix) : "",
      symbolPrefix: isSet(object.symbolPrefix) ? globalThis.String(object.symbolPrefix) : undefined,
      displayNamePrefix: isSet(object.displayNamePrefix) ? globalThis.String(object.displayNamePrefix) : undefined,
      priceMultiplier: isSet(object.priceMultiplier) ? globalThis.Number(object.priceMultiplier) : undefined,
      lotSize: isSet(object.lotSize) ? globalThis.Number(object.lotSize) : undefined,
      volumeFreezeQuantity: isSet(object.volumeFreezeQuantity)
        ? globalThis.Number(object.volumeFreezeQuantity)
        : undefined,
      tickSize: isSet(object.tickSize) ? globalThis.Number(object.tickSize) : undefined,
      expiry: isSet(object.expiry) ? Expiry.fromJSON(object.expiry) : undefined,
      strikes: globalThis.Array.isArray(object?.strikes) ? object.strikes.map((e: any) => globalThis.Number(e)) : [],
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
    };
  },

  toJSON(message: FoProto_OptionSecurityProto): unknown {
    const obj: any = {};
    if (message.securityCodePrefix !== "") {
      obj.securityCodePrefix = message.securityCodePrefix;
    }
    if (message.symbolPrefix !== undefined) {
      obj.symbolPrefix = message.symbolPrefix;
    }
    if (message.displayNamePrefix !== undefined) {
      obj.displayNamePrefix = message.displayNamePrefix;
    }
    if (message.priceMultiplier !== undefined) {
      obj.priceMultiplier = Math.round(message.priceMultiplier);
    }
    if (message.lotSize !== undefined) {
      obj.lotSize = Math.round(message.lotSize);
    }
    if (message.volumeFreezeQuantity !== undefined) {
      obj.volumeFreezeQuantity = Math.round(message.volumeFreezeQuantity);
    }
    if (message.tickSize !== undefined) {
      obj.tickSize = Math.round(message.tickSize);
    }
    if (message.expiry !== undefined) {
      obj.expiry = Expiry.toJSON(message.expiry);
    }
    if (message.strikes?.length) {
      obj.strikes = message.strikes.map((e) => Math.round(e));
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FoProto_OptionSecurityProto>, I>>(base?: I): FoProto_OptionSecurityProto {
    return FoProto_OptionSecurityProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FoProto_OptionSecurityProto>, I>>(object: I): FoProto_OptionSecurityProto {
    const message = createBaseFoProto_OptionSecurityProto();
    message.securityCodePrefix = object.securityCodePrefix ?? "";
    message.symbolPrefix = object.symbolPrefix ?? undefined;
    message.displayNamePrefix = object.displayNamePrefix ?? undefined;
    message.priceMultiplier = object.priceMultiplier ?? undefined;
    message.lotSize = object.lotSize ?? undefined;
    message.volumeFreezeQuantity = object.volumeFreezeQuantity ?? undefined;
    message.tickSize = object.tickSize ?? undefined;
    message.expiry = (object.expiry !== undefined && object.expiry !== null)
      ? Expiry.fromPartial(object.expiry)
      : undefined;
    message.strikes = object.strikes?.map((e) => e) || [];
    message.name = object.name ?? undefined;
    return message;
  },
};

function createBaseFoProto_FutureSecurityProto(): FoProto_FutureSecurityProto {
  return {
    code: "",
    symbol: undefined,
    displayName: undefined,
    priceMultiplier: undefined,
    lotSize: undefined,
    volumeFreezeQuantity: undefined,
    tickSize: undefined,
    expiry: undefined,
    name: undefined,
  };
}

export const FoProto_FutureSecurityProto = {
  encode(message: FoProto_FutureSecurityProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    if (message.symbol !== undefined) {
      writer.uint32(18).string(message.symbol);
    }
    if (message.displayName !== undefined) {
      writer.uint32(26).string(message.displayName);
    }
    if (message.priceMultiplier !== undefined) {
      writer.uint32(32).int32(message.priceMultiplier);
    }
    if (message.lotSize !== undefined) {
      writer.uint32(40).int32(message.lotSize);
    }
    if (message.volumeFreezeQuantity !== undefined) {
      writer.uint32(48).int32(message.volumeFreezeQuantity);
    }
    if (message.tickSize !== undefined) {
      writer.uint32(56).int32(message.tickSize);
    }
    if (message.expiry !== undefined) {
      Expiry.encode(message.expiry, writer.uint32(66).fork()).ldelim();
    }
    if (message.name !== undefined) {
      writer.uint32(74).string(message.name);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FoProto_FutureSecurityProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFoProto_FutureSecurityProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.code = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.symbol = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.displayName = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.priceMultiplier = reader.int32();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.lotSize = reader.int32();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.volumeFreezeQuantity = reader.int32();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.tickSize = reader.int32();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.expiry = Expiry.decode(reader, reader.uint32());
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.name = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FoProto_FutureSecurityProto {
    return {
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : undefined,
      displayName: isSet(object.displayName) ? globalThis.String(object.displayName) : undefined,
      priceMultiplier: isSet(object.priceMultiplier) ? globalThis.Number(object.priceMultiplier) : undefined,
      lotSize: isSet(object.lotSize) ? globalThis.Number(object.lotSize) : undefined,
      volumeFreezeQuantity: isSet(object.volumeFreezeQuantity)
        ? globalThis.Number(object.volumeFreezeQuantity)
        : undefined,
      tickSize: isSet(object.tickSize) ? globalThis.Number(object.tickSize) : undefined,
      expiry: isSet(object.expiry) ? Expiry.fromJSON(object.expiry) : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
    };
  },

  toJSON(message: FoProto_FutureSecurityProto): unknown {
    const obj: any = {};
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.symbol !== undefined) {
      obj.symbol = message.symbol;
    }
    if (message.displayName !== undefined) {
      obj.displayName = message.displayName;
    }
    if (message.priceMultiplier !== undefined) {
      obj.priceMultiplier = Math.round(message.priceMultiplier);
    }
    if (message.lotSize !== undefined) {
      obj.lotSize = Math.round(message.lotSize);
    }
    if (message.volumeFreezeQuantity !== undefined) {
      obj.volumeFreezeQuantity = Math.round(message.volumeFreezeQuantity);
    }
    if (message.tickSize !== undefined) {
      obj.tickSize = Math.round(message.tickSize);
    }
    if (message.expiry !== undefined) {
      obj.expiry = Expiry.toJSON(message.expiry);
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FoProto_FutureSecurityProto>, I>>(base?: I): FoProto_FutureSecurityProto {
    return FoProto_FutureSecurityProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FoProto_FutureSecurityProto>, I>>(object: I): FoProto_FutureSecurityProto {
    const message = createBaseFoProto_FutureSecurityProto();
    message.code = object.code ?? "";
    message.symbol = object.symbol ?? undefined;
    message.displayName = object.displayName ?? undefined;
    message.priceMultiplier = object.priceMultiplier ?? undefined;
    message.lotSize = object.lotSize ?? undefined;
    message.volumeFreezeQuantity = object.volumeFreezeQuantity ?? undefined;
    message.tickSize = object.tickSize ?? undefined;
    message.expiry = (object.expiry !== undefined && object.expiry !== null)
      ? Expiry.fromPartial(object.expiry)
      : undefined;
    message.name = object.name ?? undefined;
    return message;
  },
};

function createBaseFoProto_DerivedSecurityProto(): FoProto_DerivedSecurityProto {
  return {
    code: "",
    symbol: undefined,
    displayName: undefined,
    expiry: undefined,
    categoryCode: undefined,
    optionType: undefined,
  };
}

export const FoProto_DerivedSecurityProto = {
  encode(message: FoProto_DerivedSecurityProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    if (message.symbol !== undefined) {
      writer.uint32(18).string(message.symbol);
    }
    if (message.displayName !== undefined) {
      writer.uint32(26).string(message.displayName);
    }
    if (message.expiry !== undefined) {
      Expiry.encode(message.expiry, writer.uint32(34).fork()).ldelim();
    }
    if (message.categoryCode !== undefined) {
      writer.uint32(40).int32(message.categoryCode);
    }
    if (message.optionType !== undefined) {
      writer.uint32(48).int32(message.optionType);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FoProto_DerivedSecurityProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFoProto_DerivedSecurityProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.code = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.symbol = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.displayName = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.expiry = Expiry.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.categoryCode = reader.int32() as any;
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.optionType = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FoProto_DerivedSecurityProto {
    return {
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : undefined,
      displayName: isSet(object.displayName) ? globalThis.String(object.displayName) : undefined,
      expiry: isSet(object.expiry) ? Expiry.fromJSON(object.expiry) : undefined,
      categoryCode: isSet(object.categoryCode) ? securityCategory_CategoryCodeFromJSON(object.categoryCode) : undefined,
      optionType: isSet(object.optionType) ? optionTypeFromJSON(object.optionType) : undefined,
    };
  },

  toJSON(message: FoProto_DerivedSecurityProto): unknown {
    const obj: any = {};
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.symbol !== undefined) {
      obj.symbol = message.symbol;
    }
    if (message.displayName !== undefined) {
      obj.displayName = message.displayName;
    }
    if (message.expiry !== undefined) {
      obj.expiry = Expiry.toJSON(message.expiry);
    }
    if (message.categoryCode !== undefined) {
      obj.categoryCode = securityCategory_CategoryCodeToJSON(message.categoryCode);
    }
    if (message.optionType !== undefined) {
      obj.optionType = optionTypeToJSON(message.optionType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FoProto_DerivedSecurityProto>, I>>(base?: I): FoProto_DerivedSecurityProto {
    return FoProto_DerivedSecurityProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FoProto_DerivedSecurityProto>, I>>(object: I): FoProto_DerivedSecurityProto {
    const message = createBaseFoProto_DerivedSecurityProto();
    message.code = object.code ?? "";
    message.symbol = object.symbol ?? undefined;
    message.displayName = object.displayName ?? undefined;
    message.expiry = (object.expiry !== undefined && object.expiry !== null)
      ? Expiry.fromPartial(object.expiry)
      : undefined;
    message.categoryCode = object.categoryCode ?? undefined;
    message.optionType = object.optionType ?? undefined;
    return message;
  },
};

function createBaseCashSecurityProto(): CashSecurityProto {
  return {
    code: "",
    symbol: undefined,
    displayName: undefined,
    series: undefined,
    priceMultiplier: undefined,
    logoUrl: undefined,
    categoryCode: undefined,
    hasFo: undefined,
    lotSize: undefined,
    volumeFreezeQuantity: undefined,
    tickSize: undefined,
    instrument: undefined,
    urlIdentifier: undefined,
    foData: undefined,
    companyCode: undefined,
    surveillanceIndicator: undefined,
    hasComponents: undefined,
    surveillanceIndicatorText: undefined,
    exchangeSymbol: undefined,
    partOfCAS: undefined,
    tradeable: undefined,
  };
}

export const CashSecurityProto = {
  encode(message: CashSecurityProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    if (message.symbol !== undefined) {
      writer.uint32(18).string(message.symbol);
    }
    if (message.displayName !== undefined) {
      writer.uint32(26).string(message.displayName);
    }
    if (message.series !== undefined) {
      writer.uint32(34).string(message.series);
    }
    if (message.priceMultiplier !== undefined) {
      writer.uint32(40).int32(message.priceMultiplier);
    }
    if (message.logoUrl !== undefined) {
      writer.uint32(50).string(message.logoUrl);
    }
    if (message.categoryCode !== undefined) {
      writer.uint32(56).int32(message.categoryCode);
    }
    if (message.hasFo !== undefined) {
      writer.uint32(64).bool(message.hasFo);
    }
    if (message.lotSize !== undefined) {
      writer.uint32(72).int32(message.lotSize);
    }
    if (message.volumeFreezeQuantity !== undefined) {
      writer.uint32(80).int32(message.volumeFreezeQuantity);
    }
    if (message.tickSize !== undefined) {
      writer.uint32(88).int32(message.tickSize);
    }
    if (message.instrument !== undefined) {
      writer.uint32(98).string(message.instrument);
    }
    if (message.urlIdentifier !== undefined) {
      writer.uint32(106).string(message.urlIdentifier);
    }
    if (message.foData !== undefined) {
      FoProto.encode(message.foData, writer.uint32(114).fork()).ldelim();
    }
    if (message.companyCode !== undefined) {
      writer.uint32(122).string(message.companyCode);
    }
    if (message.surveillanceIndicator !== undefined) {
      writer.uint32(128).int32(message.surveillanceIndicator);
    }
    if (message.hasComponents !== undefined) {
      writer.uint32(136).bool(message.hasComponents);
    }
    if (message.surveillanceIndicatorText !== undefined) {
      writer.uint32(146).string(message.surveillanceIndicatorText);
    }
    if (message.exchangeSymbol !== undefined) {
      writer.uint32(154).string(message.exchangeSymbol);
    }
    if (message.partOfCAS !== undefined) {
      writer.uint32(160).bool(message.partOfCAS);
    }
    if (message.tradeable !== undefined) {
      writer.uint32(168).bool(message.tradeable);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CashSecurityProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCashSecurityProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.code = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.symbol = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.displayName = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.series = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.priceMultiplier = reader.int32();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.logoUrl = reader.string();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.categoryCode = reader.int32() as any;
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.hasFo = reader.bool();
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.lotSize = reader.int32();
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.volumeFreezeQuantity = reader.int32();
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.tickSize = reader.int32();
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.instrument = reader.string();
          continue;
        case 13:
          if (tag !== 106) {
            break;
          }

          message.urlIdentifier = reader.string();
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }

          message.foData = FoProto.decode(reader, reader.uint32());
          continue;
        case 15:
          if (tag !== 122) {
            break;
          }

          message.companyCode = reader.string();
          continue;
        case 16:
          if (tag !== 128) {
            break;
          }

          message.surveillanceIndicator = reader.int32();
          continue;
        case 17:
          if (tag !== 136) {
            break;
          }

          message.hasComponents = reader.bool();
          continue;
        case 18:
          if (tag !== 146) {
            break;
          }

          message.surveillanceIndicatorText = reader.string();
          continue;
        case 19:
          if (tag !== 154) {
            break;
          }

          message.exchangeSymbol = reader.string();
          continue;
        case 20:
          if (tag !== 160) {
            break;
          }

          message.partOfCAS = reader.bool();
          continue;
        case 21:
          if (tag !== 168) {
            break;
          }

          message.tradeable = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CashSecurityProto {
    return {
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : undefined,
      displayName: isSet(object.displayName) ? globalThis.String(object.displayName) : undefined,
      series: isSet(object.series) ? globalThis.String(object.series) : undefined,
      priceMultiplier: isSet(object.priceMultiplier) ? globalThis.Number(object.priceMultiplier) : undefined,
      logoUrl: isSet(object.logoUrl) ? globalThis.String(object.logoUrl) : undefined,
      categoryCode: isSet(object.categoryCode) ? securityCategory_CategoryCodeFromJSON(object.categoryCode) : undefined,
      hasFo: isSet(object.hasFo) ? globalThis.Boolean(object.hasFo) : undefined,
      lotSize: isSet(object.lotSize) ? globalThis.Number(object.lotSize) : undefined,
      volumeFreezeQuantity: isSet(object.volumeFreezeQuantity)
        ? globalThis.Number(object.volumeFreezeQuantity)
        : undefined,
      tickSize: isSet(object.tickSize) ? globalThis.Number(object.tickSize) : undefined,
      instrument: isSet(object.instrument) ? globalThis.String(object.instrument) : undefined,
      urlIdentifier: isSet(object.urlIdentifier) ? globalThis.String(object.urlIdentifier) : undefined,
      foData: isSet(object.foData) ? FoProto.fromJSON(object.foData) : undefined,
      companyCode: isSet(object.companyCode) ? globalThis.String(object.companyCode) : undefined,
      surveillanceIndicator: isSet(object.surveillanceIndicator)
        ? globalThis.Number(object.surveillanceIndicator)
        : undefined,
      hasComponents: isSet(object.hasComponents) ? globalThis.Boolean(object.hasComponents) : undefined,
      surveillanceIndicatorText: isSet(object.surveillanceIndicatorText)
        ? globalThis.String(object.surveillanceIndicatorText)
        : undefined,
      exchangeSymbol: isSet(object.exchangeSymbol) ? globalThis.String(object.exchangeSymbol) : undefined,
      partOfCAS: isSet(object.partOfCAS) ? globalThis.Boolean(object.partOfCAS) : undefined,
      tradeable: isSet(object.tradeable) ? globalThis.Boolean(object.tradeable) : undefined,
    };
  },

  toJSON(message: CashSecurityProto): unknown {
    const obj: any = {};
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.symbol !== undefined) {
      obj.symbol = message.symbol;
    }
    if (message.displayName !== undefined) {
      obj.displayName = message.displayName;
    }
    if (message.series !== undefined) {
      obj.series = message.series;
    }
    if (message.priceMultiplier !== undefined) {
      obj.priceMultiplier = Math.round(message.priceMultiplier);
    }
    if (message.logoUrl !== undefined) {
      obj.logoUrl = message.logoUrl;
    }
    if (message.categoryCode !== undefined) {
      obj.categoryCode = securityCategory_CategoryCodeToJSON(message.categoryCode);
    }
    if (message.hasFo !== undefined) {
      obj.hasFo = message.hasFo;
    }
    if (message.lotSize !== undefined) {
      obj.lotSize = Math.round(message.lotSize);
    }
    if (message.volumeFreezeQuantity !== undefined) {
      obj.volumeFreezeQuantity = Math.round(message.volumeFreezeQuantity);
    }
    if (message.tickSize !== undefined) {
      obj.tickSize = Math.round(message.tickSize);
    }
    if (message.instrument !== undefined) {
      obj.instrument = message.instrument;
    }
    if (message.urlIdentifier !== undefined) {
      obj.urlIdentifier = message.urlIdentifier;
    }
    if (message.foData !== undefined) {
      obj.foData = FoProto.toJSON(message.foData);
    }
    if (message.companyCode !== undefined) {
      obj.companyCode = message.companyCode;
    }
    if (message.surveillanceIndicator !== undefined) {
      obj.surveillanceIndicator = Math.round(message.surveillanceIndicator);
    }
    if (message.hasComponents !== undefined) {
      obj.hasComponents = message.hasComponents;
    }
    if (message.surveillanceIndicatorText !== undefined) {
      obj.surveillanceIndicatorText = message.surveillanceIndicatorText;
    }
    if (message.exchangeSymbol !== undefined) {
      obj.exchangeSymbol = message.exchangeSymbol;
    }
    if (message.partOfCAS !== undefined) {
      obj.partOfCAS = message.partOfCAS;
    }
    if (message.tradeable !== undefined) {
      obj.tradeable = message.tradeable;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CashSecurityProto>, I>>(base?: I): CashSecurityProto {
    return CashSecurityProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CashSecurityProto>, I>>(object: I): CashSecurityProto {
    const message = createBaseCashSecurityProto();
    message.code = object.code ?? "";
    message.symbol = object.symbol ?? undefined;
    message.displayName = object.displayName ?? undefined;
    message.series = object.series ?? undefined;
    message.priceMultiplier = object.priceMultiplier ?? undefined;
    message.logoUrl = object.logoUrl ?? undefined;
    message.categoryCode = object.categoryCode ?? undefined;
    message.hasFo = object.hasFo ?? undefined;
    message.lotSize = object.lotSize ?? undefined;
    message.volumeFreezeQuantity = object.volumeFreezeQuantity ?? undefined;
    message.tickSize = object.tickSize ?? undefined;
    message.instrument = object.instrument ?? undefined;
    message.urlIdentifier = object.urlIdentifier ?? undefined;
    message.foData = (object.foData !== undefined && object.foData !== null)
      ? FoProto.fromPartial(object.foData)
      : undefined;
    message.companyCode = object.companyCode ?? undefined;
    message.surveillanceIndicator = object.surveillanceIndicator ?? undefined;
    message.hasComponents = object.hasComponents ?? undefined;
    message.surveillanceIndicatorText = object.surveillanceIndicatorText ?? undefined;
    message.exchangeSymbol = object.exchangeSymbol ?? undefined;
    message.partOfCAS = object.partOfCAS ?? undefined;
    message.tradeable = object.tradeable ?? undefined;
    return message;
  },
};

function createBaseExchangeSecurityProto(): ExchangeSecurityProto {
  return { exchange: 0, cashSecurities: [] };
}

export const ExchangeSecurityProto = {
  encode(message: ExchangeSecurityProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange);
    }
    for (const v of message.cashSecurities) {
      CashSecurityProto.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ExchangeSecurityProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExchangeSecurityProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.exchange = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.cashSecurities.push(CashSecurityProto.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExchangeSecurityProto {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      cashSecurities: globalThis.Array.isArray(object?.cashSecurities)
        ? object.cashSecurities.map((e: any) => CashSecurityProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ExchangeSecurityProto): unknown {
    const obj: any = {};
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange);
    }
    if (message.cashSecurities?.length) {
      obj.cashSecurities = message.cashSecurities.map((e) => CashSecurityProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExchangeSecurityProto>, I>>(base?: I): ExchangeSecurityProto {
    return ExchangeSecurityProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExchangeSecurityProto>, I>>(object: I): ExchangeSecurityProto {
    const message = createBaseExchangeSecurityProto();
    message.exchange = object.exchange ?? 0;
    message.cashSecurities = object.cashSecurities?.map((e) => CashSecurityProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAllSecuritiesResponseProto(): AllSecuritiesResponseProto {
  return { exchangeSecurities: [] };
}

export const AllSecuritiesResponseProto = {
  encode(message: AllSecuritiesResponseProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.exchangeSecurities) {
      ExchangeSecurityProto.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AllSecuritiesResponseProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAllSecuritiesResponseProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.exchangeSecurities.push(ExchangeSecurityProto.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AllSecuritiesResponseProto {
    return {
      exchangeSecurities: globalThis.Array.isArray(object?.exchangeSecurities)
        ? object.exchangeSecurities.map((e: any) => ExchangeSecurityProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AllSecuritiesResponseProto): unknown {
    const obj: any = {};
    if (message.exchangeSecurities?.length) {
      obj.exchangeSecurities = message.exchangeSecurities.map((e) => ExchangeSecurityProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AllSecuritiesResponseProto>, I>>(base?: I): AllSecuritiesResponseProto {
    return AllSecuritiesResponseProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AllSecuritiesResponseProto>, I>>(object: I): AllSecuritiesResponseProto {
    const message = createBaseAllSecuritiesResponseProto();
    message.exchangeSecurities = object.exchangeSecurities?.map((e) => ExchangeSecurityProto.fromPartial(e)) || [];
    return message;
  },
};

function createBasePrimaryCompanyIdentifier(): PrimaryCompanyIdentifier {
  return { primaryCode: "", primaryExchange: "" };
}

export const PrimaryCompanyIdentifier = {
  encode(message: PrimaryCompanyIdentifier, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.primaryCode !== "") {
      writer.uint32(10).string(message.primaryCode);
    }
    if (message.primaryExchange !== "") {
      writer.uint32(18).string(message.primaryExchange);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PrimaryCompanyIdentifier {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePrimaryCompanyIdentifier();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.primaryCode = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.primaryExchange = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PrimaryCompanyIdentifier {
    return {
      primaryCode: isSet(object.primaryCode) ? globalThis.String(object.primaryCode) : "",
      primaryExchange: isSet(object.primaryExchange) ? globalThis.String(object.primaryExchange) : "",
    };
  },

  toJSON(message: PrimaryCompanyIdentifier): unknown {
    const obj: any = {};
    if (message.primaryCode !== "") {
      obj.primaryCode = message.primaryCode;
    }
    if (message.primaryExchange !== "") {
      obj.primaryExchange = message.primaryExchange;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PrimaryCompanyIdentifier>, I>>(base?: I): PrimaryCompanyIdentifier {
    return PrimaryCompanyIdentifier.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PrimaryCompanyIdentifier>, I>>(object: I): PrimaryCompanyIdentifier {
    const message = createBasePrimaryCompanyIdentifier();
    message.primaryCode = object.primaryCode ?? "";
    message.primaryExchange = object.primaryExchange ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
